import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Divider from "@material-ui/core/Divider";
import InputBase from "@material-ui/core/InputBase";
import { Backdrop } from "@material-ui/core";
import debounce from "lodash-es/debounce";
import cloneDeep from "lodash-es/cloneDeep";
import Modal from "@material-ui/core/Modal";
import { makeStyles } from "@material-ui/core/styles";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import $ from "jquery";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import axios from "../../axios";
import TableBackdrop from "../../components/IFormDesignerLayout/IFormDesignerComponents/TableProperties/TableBackdrop";
import {
  changeControlProperty,
  createUniqueId,
  getDevice,
  getFormId,
  sendRequestForControl,
  updateStepIndex,
} from "../../components/IFormDesignerLayout/IFormDesignerLogic";
import { ThemeJSON } from "../../components/IFormDesignerLayout/Theme/ThemeJSON";
import styles from "../../components/LeftNavigation/DesignerControls/BasicControls.module.css";
import "../../components/IFormDesignerLayout/IFormDesignerComponents/RadioProperties/RadioProperties.css";
import ColumnPropertiesJson from "../../components/Properties/ColumnPropertiesJson";
import ControlsMap from "../../components/Properties/PropertiesConfiguration";
import AddColumnIcon from "../../Icons/AddColumnIcon";
import CodeIcon from "../../Icons/CodeIcon";
import CollapsibleArrowDown from "../../Icons/CollapsibleArrowDown";
import CollapsibleArrowUp from "../../Icons/CollapsibleArrowUp";
import Cross from "../../Icons/Cross.jsx";
import DragAdvListview from "../../Icons/DragAdvListview";
import SvgEditIcon from "../../Icons/EditIcon";
import Svgdrag from "../../Icons/SectionIcons/drag";
import LinkIcon from "../../Icons/LinkIcon";
import PlusOrange from "../../Icons/PlusOrange";
import PlusBlue from "../../Icons/PlusBlue";
import RedCross from "../../Icons/RedCross";
import {ReactComponent as TabColumn1} from "../../Icons/TabColumn1.svg";
import {ReactComponent as TabColumn2} from "../../Icons/TabColumn2.svg";
import {ReactComponent as TabColumn3} from "../../Icons/TabColumn3.svg";
import {ReactComponent as TabColumn4} from "../../Icons/TabColumn4.svg";
import {ReactComponent as TabColumn5} from "../../Icons/TabColumn5.svg";
import {ReactComponent as TabColumn6} from "../../Icons/TabColumn6.svg";
import DOTS from "../../Icons/ThreeDots.jsx";
import { AppContext } from "../../Resources/CanvasContextFile";
import { regexValidator } from "../../Resources/globalFunctions";
import ModalItem from "../../UI/BasicFormControls/Report/ReportModal";

import ReportModal from "../../UI/BasicFormControls/Report/ReportModal";

import ActiveIcon from "../ActiveIcon/ActiveIcon";
import ErrorMessageComponent from "../ErrorMessageComponent/ErrorMessageComponent";
import ImageUploadBtn from "../ImageUploadBtn/ImageUploadBtn";
import ToggleBtnQuickTool from "../ToggleBtn/ToggleBtnQuickTool";
import ToggleBtn3 from "../ToggleBtn/ToggleBtn3";
import { properties, elemTypeJsonMap } from "./properties";
import CustomizedAlert from "../../ReusableComponents/Alert/CustomizedAlert";

import DateTimePickerType from "../../Icons/DateTimePickerType";
import Style1Icon from "../../Icons/Style1Icon";
import Style2Icon from "../../Icons/Style2Icon";
import Style3Icon from "../../Icons/Style3Icon";
import DatePickerType from "../../Icons/DatePickerType";
import { useDispatch, addContexts, useSelector } from "../../Redux";

import MappingFile from "../Mapping/MappingFile";

import { validateCustomControlId } from "../../components/IFormDesignerLayout/RequestLogic";
import { updateUserId } from "../../components/IFormDesignerLayout/Logic/UserIdLogic";
import { CodeOutlined } from "@material-ui/icons";
import { useCallback } from "react";
import SimpleLoader from "../../UI/General/SimpleLoader";
import ImageEditor from "../../components/IFormDesignerLayout/IFormDesignerComponents/ImageCarouselProperties/ImageEditor";
import { GetStateFromData } from "../../components/CustomHooks/CustomHooks.js";
import { updateFormStateContextWithoutRender, updateStateInRedux } from "../../Redux/Actions/FormStateActions.js";
import { functions } from "../../components/IFormDesignerLayout/ApplicationAPI/applicationApi.js";
import { findFrameColumnLayout } from "../../components/IFormDesignerLayout/SectionLayoutLogic.jsx";

const useStyles = makeStyles({
  root: {
    backgroundColor: "transparent",
  },
  paper: {
    backgroundColor: "transparent",
    boxShadow: "none",
    overflow: "hidden",
  },
  cardContent: {
    padding: "0px",
  },
  header: {
    height: "39px",
    padding: "10px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "0px 0px 10px #00000029",
    borderRadius: "2px",
    opacity: 1,
  },
  head: {
    textAlign: "left",
    font: "normal normal bold 14px/17px Open Sans",
    letterSpacing: "0px",
    color: "#0072C6",
    opacity: 1,
  },
  body: {
    padding: "11px",
  },
  quickTools: {
    position: "fixed",
    width: "280px",
    zIndex: "999",
    left: "50%",
    top: "53%",
    transform: "translate(-50%,-50%)",
    boxShadow: "0px 0px 10px #00000029",
    borderRadius: "2px",
    opacity: "1",
    background: "#FFFFFF",
    textAlign: "left",
    cursor: "default",
  },
  dialog: {
    position: "absolute",
    maxWidth: "280px",
    overflow: "hidden",
    zIndex: "0",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "0px 0px 10px #00000029",
    borderRadius: "2px",
    direction:
      window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"
        ? "rtl"
        : "ltr",
  },
  dialogTitle: {
    height: "39px",
    padding: "2px 10px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "0px 0px 10px #00000029",
    borderRadius: "2px",
    opacity: 1,
  },
  dialogHead: {
    paddingRight: "10px",
    textAlign:
      window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"
        ? "right"
        : "left",
    font: "normal normal bold 14px/17px Open Sans",
    letterSpacing: "0px",
    color: "#0072C6",
    opacity: 1,
  },
  controlHead: {
    textAlign: "left",
    font: "normal normal 600 12px/16px Open Sans",
    letterSpacing: "0px",
    color: "#000000",
    opacity: 1,
  },
  dialogContent: {
    padding: "11px",
  },
  dialogActions: {
    height: "28px",
    width: "100%",
    background: "#F5F5F5 0% 0% no-repeat padding-box",
    opacity: 1,
    margin: "0px",
    padding: "0px",
  },
  divider: {
    backgroundColor: "#E4E4E4",
  },
  btn1: {
    minWidth: "88px",
    width: "33.33%",
    height: "28px",
    margin: "0px !important",
    padding: "5px 0px 0px 0px",
    background: "#E6E6EB 0% 0% no-repeat padding-box",
    font: "normal normal 600 10px/16px Open Sans",
    color: "#000000",
    textAlign: "center",
    letterSpacing: "0px",
    opacity: 1,
    "&:hover": {
      cursor: "pointer",
    },
  },
  btn2: {
    minWidth: "88px",
    width: "33.33%",
    height: "28px",
    margin: "0px !important",
    padding: "5px 0px 0px 0px",
    background: "#E6E6EB 0% 0% no-repeat padding-box",
    font: "normal normal 600 10px/16px Open Sans",
    color: "#000000",
    textAlign: "center",
    letterSpacing: "0px",
    opacity: 1,
    "&:hover": {
      cursor: "pointer",
    },
  },
  btn3: {
    minWidth: "88px",
    width: "33.33%",
    height: "28px",
    margin: "0px !important",
    padding: "5px 0px 0px 0px",
    background: "#0072C6 0% 0% no-repeat padding-box",
    font: "normal normal 600 10px/16px Open Sans",
    color: "#ffffff",
    textAlign: "center",
    letterSpacing: "0px",
    opacity: 1,
    "&:hover": {
      cursor: "pointer",
    },
  },
  btn1label: {},
  btn2label: {},
  btn3label: {},
  toggleBtn: {
    display: "flex",
    justifyContent: "space-between",
    padding: "5px 0px",
    zIndex: "10",
    width: "100%",
  },
  toggleshort: {
    display: "inline-flex",
    padding: "5px 0px",
    zIndex: "10",
    alignItems: "center",
    marginLeft: window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA" ? "" : "28px",
    marginRight: window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA" ? "28px" : "",
    "& > div": {
      height: "unset",
      position: "unset",
      border: "none",
      boxShadow: "none",
    },
  },
  toggleLabel: {
    color: "#2E2E2E",
    font: "normal normal normal 12px/17px Open Sans",
    letterSpacing: "0px",
    opacity: 1,
    position: "unset",
  },
  labelTextBox: {
    marginTop: "3px",
  },
  label: {
    marginBottom: "5px",
    color: "#000000",
    font: "normal normal normal 12px/17px Open Sans",
    letterSpacing: "0px",
    opacity: 1,
  },
  textArea: {
    width: "100%",
    color: "#202020",
    font: "normal normal normal 12px/17px Open Sans",
    letterSpacing: "0px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    border: "1px solid #C4C4C4",
    borderRadius: "2px",
    opacity: 1,
    resize: "none",
  },
  stepIndex: {
    display: "flex",
    justifyContent: "space-between",
    padding: "2px",
    alignItems: "center",
    marginRight: "10px",
  },
  addSubstep: {
    color: "#338ED1",
    border: "1px solid #338ED1",
    padding: "3px",
  },
  parentDivTopBottom: {
    marginTop: "0px !important",
  },
  topBottomLabel: {
    marginBottom: "5px",
    display: "inline-block",
    color: "#000000",
    font: "normal normal normal 12px/17px Open Sans",
    letterSpacing: "0px",
    opacity: 1,
  },
  fullWidthTextBox: {
    width: "100%",
    height: "24px",
    color: "#202020",
    font: "normal normal normal 12px/17px Open Sans",
    letterSpacing: "0px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    border: "1px solid #C4C4C4",
    borderRadius: "2px",
    opacity: 1,
  },
  test: {
    padding: "2% !important",
  },
});

export default function QuickTools(props) {
  const classes = useStyles();

  const { t } = useTranslation();
  const translationStyles1 =
    window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA";

  const currCtrl = { ...props.selectedControl };

  const [selectedControl, setSelectedControl] = useState(props.selectedControl);
  const [isButtonHover, setIsButtonHover] = useState(false);
  const [isButtonHover2, setIsButtonHover2] = useState(false);
  const style = { ...props.selectedControl.style };

  const contexts = GetStateFromData(props.containerId);
  const currentDeviceOnApp = getDevice();

  const {
    updateJson,
    changeSectionLayout,
    formState2,
    openQuickToolFor,
    setOpenQuickToolFor,
    setIsMenuSubMenuAdded,
    openCanvasForSubform,
    setIsTableBackdropOpen,
    populateFormStateFromJsonOnAction,
    setOpenLoader
  } = contexts.contexts;
  const dispatch = useDispatch()

  const setSelectedControlVar = contexts.contexts.setSelectedControl;
  const setOpenPropertiesVar = contexts.contexts.setOpenProperties;
  const setfromQuickProps = contexts.contexts.setfromQuickProps;

  const { updatedComponentInFormState, removeAndUpdateComponentInFormState } =
    updateJson;


  const [alertData, setAlertData] = useState({
    open: false,
    showConfirm: "showNotification",
  });
  const [customId,setCustomId]=useState(props.selectedControl.style["CustomId"])
  const [errorMessageId, setErrorMessageId] = useState(false);
  const [showTableBackdrop, setShowTableBackdrop] = useState(false);
  const [selectedColumn, setSelectedColumn] = useState();
  const [selectedColumnIndex, setSelectedColumnIndex] = useState(0);
  const [existingColumnsIndex, setExistingColumnsIndex] = useState();
  const [columnsStyle, setColumnsStyle] = useState();
  const [columnNamesList, setColumnNamesList] = useState();
  const [selectedControlCLone, setSelectedControlClone] = useState(cloneDeep(props.selectedControl));
  const [formstateCLone, setFormstateClone] = useState(cloneDeep(formState2));
  const [addIcon, setAddIcon] = useState(false);
  const [jsonIcons, setjsonForIcons] = useState({});

  const [filter, setFilter] = useState("");
  const [open, setOpen] = React.useState(false);

  const [mappingField, setMappingField] = useState(false);
  const [editableImage, setEditableImage] = useState(false);
  const [imgInd, setImgInd] = useState(-1);

  var prevValue = "";
  var totalSheets = 0;
  if (selectedControl.children && selectedControl.children.length) {
    var totalSheets = selectedControl.children.length;
  }

  const [activeStep, setActiveStep] = useState(
    selectedControl && selectedControl.children && selectedControl.children[0]
      ? selectedControl.children[0].id
      : 0
  );

  const [draggedImagePosition, setDraggedImagePosition] = useState();
  const [shouldShowLoader, setShouldShowLoader] = useState(true);

  var setSelectedControlForFullProp;
  setSelectedControlForFullProp = setSelectedControlVar;

  useEffect(() => {
    setSelectedControl(props.selectedControl);
  }, [props.selectedControl]);

  useEffect(() => {
    setSelectedControlClone(cloneDeep(props.selectedControl));
    setFormstateClone(cloneDeep(formState2));
  }, []);

  useEffect(() => {
    console.log();
    if (props.open) {
      if (setSelectedControlVar !== selectedControl) {
        setSelectedControlForFullProp({ ...selectedControl });
      } else {
        setSelectedControlForFullProp(setSelectedControlVar);
      }

      setSelectedControlVar(currCtrl);

      if (selectedControl !== props.selectedControl) {
        setSelectedControl({ ...props.selectedControl });
      } else {
        // setSelectedControl(selectedControl);
        setSelectedControl( () => {return {...selectedControl} } )
      }
    }
  }, []);

  console.log("counter", "checking quicktoolsrender");

  var Items = [];

  function handleOpenCrop(index) {
    setImgInd(index);
    setEditableImage(true);
  }

  function handleEditImgClose() {
    setEditableImage(false);
  }

  function handleImageEditing(arg, imageFile, imgStyle) {
    if (arg === "Save2") {
      props.selectedControl.style.imageList[imgInd].imageStyle = imgStyle;
    } else if (arg === "Save") {
      props.selectedControl.style.imageList[imgInd].imageStyle = imgStyle;
      props.selectedControl.style.imageList[imgInd].imageFile = imageFile;
    }
    updatedComponentInFormState(
      props.selectedControl.id,
      props.selectedControl
    );
  }

  function setToggleValue(e, field) {
    const value = !(e.target ? e.target.value : e.current.checked);
    
    let currControl = { ...selectedControl };
    currControl.style["AddIcon"] = `${value}`;

    setAddIcon(value);
    if (value == "false") {
      Object.values(selectedControl.children).map((key, index) => {
        if (jsonIcons[key.id] !== undefined) {
          currControl.children[index]["icon"]["name"] = "";
          currControl.children[index]["icon"]["file"] = "";
        }
      });
    } else {
      Object.values(selectedControl.children).map((key, index) => {
        if (jsonIcons[key.id] !== undefined) {
          currControl.children[index]["icon"]["name"] = jsonIcons[key.id].name;
          currControl.children[index]["icon"]["file"] = jsonIcons[key.id].file;
        }
      });
    }
    if (selectedControl !== currControl) {
      setSelectedControl({ ...currControl });
    } else {
      // setSelectedControl(selectedControl);
      setSelectedControl( () => {return {...selectedControl} } )
    }

    updatedComponentInFormState(selectedControl.id, selectedControl);
  }

  function updateSheetName(sheetId) {
    let currControl = { ...selectedControl };
    if (document.getElementById(sheetId).value === "") {
    }
    var updatedName = document.getElementById(sheetId + "SheetNameInput").value;
    if (updatedName !== prevValue && updatedName !== "") {
      prevValue = updatedName;
      let valid = true;
      if (ControlsMap["label"] && ControlsMap["label"]["regexType"]) {
        if (
          regexValidator(updatedName, ControlsMap["label"]["regexType"]) !==
          true
        ) {
          valid = false;
          if (updatedName.trim().length > 0) {
            showAlertConfirmNotifications({
              open: true,
              showConfirm: "showNotification",
              alertType: "error",
              alertContentKey: "NON_PERMISSIBLE",
            });

          }
        }
      }
      if (valid) {
        currControl.children.forEach(function (entry) {
          if (entry.id === sheetId) {
            entry.tabChildName = updatedName;
          }
        });
      }

      if (selectedControl !== currControl) {
        setSelectedControl({ ...currControl });
      } else {
        // setSelectedControl(selectedControl);
        setSelectedControl( () => {return {...selectedControl} } )
      }
    }
  }

  function updateStepName(sheetId) {
    let currControl = { ...selectedControl };
    let updatedName = document.getElementById(sheetId + "stepName").value;

      if (!updatedName.trim()) {
        setAlertData({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: "Empty_Label_Not_Allowed",
          boxStyle:true
        });
        return false;
      }

    if (updatedName !== prevValue && updatedName !== "") {
      prevValue = updatedName;
      let valid = true;
      if (ControlsMap?.["label"]?.["regexType"]) {
        if (
          regexValidator(updatedName, ControlsMap["label"]["regexType"]) !==
          true
        ) {
          valid = false;
          if (updatedName.trim().length > 0) {
            showAlertConfirmNotifications({
              open: true,
              showConfirm: "showNotification",
              alertType: "error",
              alertContentKey: "NON_PERMISSIBLE",
            });
          }
        }
      }
      if (valid) {
        currControl.children.forEach(function (entry) {
          if (entry.id === sheetId) {
            entry.stepName = updatedName;
          }
        });
      }

      if (selectedControl !== currControl) {
        setSelectedControl({ ...currControl });
      } else {
        // setSelectedControl(selectedControl);
        setSelectedControl( () => {return {...selectedControl} } )
      }

      updatedComponentInFormState(currControl.id, currControl);
    }
  }

  function showAlertConfirmNotifications(dataTobeSet) {
    setAlertData(dataTobeSet);
  }

  function confirmDeletion(sheetId, sheetIndex) {
    setAlertData({
      ...ControlsMap["customizedAlertConfirmationData"],
      open: true,
      Id: sheetId,
      sheetIndex: sheetIndex,
    });
  }

  function deleteSheet(sheetId, sheetInd) {
    
    const frameIndex =
      props.selectedControl && props.selectedControl.frameIndex;
    const elementIndex =
      props.selectedControl && props.selectedControl.elementIndex;

    const extraDetails = {
      sheetId: sheetInd,
      frameIndex: frameIndex,
      elementIndex: elementIndex,
      isSubForm: openCanvasForSubform === "subform" ? true : false,
      isAdvanceListview:
        openCanvasForSubform === "advanceListviewFromScratch" ? true : false,
      id: alertData?.Id,
    };
    let controlData = props.selectedControl;
    if (props.selectedControl.children.length > 1) {
      sendRequestForControl(frameIndex, "delete", "tabSheet123", extraDetails)
        .then((response) => {
          
          if (response.data.status === 0) {
            controlData.children.splice(sheetInd, 1);

            const newData = controlData.children.map((item) =>
              sheetInd < item.sheetIndex
                ? { ...item, sheetIndex: item.sheetIndex - 1 }
                : item
            );

            controlData.children = newData;

            updatedComponentInFormState(controlData.id, controlData);
            setOpenLoader(false);
          } else if (response.data.status === 1) {
            showAlertConfirmNotifications({
              open: true,
              showConfirm: "showNotification",
              alertType: "error",
              alertContentKey: "Reopen_Form",
            });
          }
        })
        .catch((err) => {
          setOpenLoader(false);
          window.loading(false)
          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentKey: `${t("Unable_to_delete_Tab_Sheet")}`,
          });
        });
    } else {
      showAlertConfirmNotifications({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        alertContentKey: "CANT_DEL_LAST_TABCHILD",
      });
    }
  }

  function deleteMainMenu(stepDetails, stepIndex) {
    var controlData = props.selectedControl;
    var frameIndex = props.selectedControl && props.selectedControl.frameIndex;
    var extraDetails = {};
    extraDetails.stepIndex = stepIndex;
    extraDetails.elem_type = "MainMenu";
    extraDetails.id = stepDetails;
    sendRequestForControl(frameIndex, "delete", "step", extraDetails)
      .then((response) => {
        if (response?.data?.status === 0) {
          controlData.children.splice(stepIndex, 1);

          const newData = controlData.children.map((item) =>
            stepIndex < item.MainMenuIndex
              ? { ...item, MainMenuIndex: item.MainMenuIndex - 1 }
              : item
          );

          setIsMenuSubMenuAdded((prev) => !prev);
          controlData.children = newData;
          updatedComponentInFormState(controlData.id, controlData);
          setOpenLoader(false);
        } else if (response.data.status === 1) {
          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentKey: "Reopen_Form",
          });
        } else {
          setOpenLoader(false);
          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentKey: "Unable to delete MainMenu",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        window.loading(false)
        setOpenLoader(false);
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: "Unable to delete MainMenu",
        });
      });
  }

  const addSheet = (data) => {
    let currControl = { ...data };
    // if (currControl.children.length <= window?.psh_configs?.tabSheetCount - 1) {
      var controlData = currControl;
      var frameIndex = currControl && currControl.frameIndex;
      var controlType = "sheet";
      var extraDetails = {};
      if (currControl && currControl.elementIndex) {
        extraDetails.elementIndex = currControl.elementIndex;
      }

      const tabControl = document.getElementById(props?.selectedControl?.id);
      if (tabControl) {
        extraDetails.insideMenu = tabControl.closest(`[elem_type=Menu]`)
          ? true
          : false;
        if (extraDetails.insideMenu) {
          const activeJsonString = document
            .querySelector(".menuMain_Id")
            .getAttribute("activeJson");
          const activeJson = activeJsonString
            ? JSON.parse(activeJsonString || null)
            : {};

          extraDetails.stepIndex =
            activeJson.MainMenuIndex || activeJson.MainMenuIndex === 0
              ? activeJson.MainMenuIndex
              : "-1";
          extraDetails.substepIndex =
            activeJson.SubMenuIndex || activeJson.SubMenuIndex === 0
              ? activeJson.SubMenuIndex
              : "-1";
          extraDetails.subChildMenuIndex =
            activeJson.subChildMenuIndex || activeJson.subChildMenuIndex === 0
              ? activeJson.subChildMenuIndex
              : "-1";
        }
        extraDetails.isSubForm =
          openCanvasForSubform === "subform" ? true : false;
        extraDetails.isAdvanceListview =
          openCanvasForSubform === "advanceListviewFromScratch" ? true : false;
      }

      sendRequestForControl(frameIndex, "add", controlType, extraDetails)
        .then((response) => {
          var newSheet = response.data;
          var controlId = controlData.id;

          let ColumnLayout = newSheet.ColumnLayout;
          if (
            ColumnLayout !== null &&
            ColumnLayout !== undefined &&
            ColumnLayout !== ""
          ) {
            try {
              const MaxIteration = 13;
              ColumnLayout = parseInt(ColumnLayout);
              if(ColumnLayout > MaxIteration) ColumnLayout = MaxIteration;

              var rowElem = {};
              rowElem.id = createUniqueId("row");
              rowElem.children = [];
              rowElem.elem_type = "row";
              rowElem.frameIndex =
                controlData.children[0].children[0].frameIndex;
              rowElem.parent_id = controlData.children[0].children[0].parent_id;

              if(ColumnLayout < MaxIteration) {
                for (let clm = 0; clm < ColumnLayout; clm++) {
                  var col = {};
                  col.id = createUniqueId("column"); //newElement;
                  col.elem_type = "column";
                  const w = 12 / ColumnLayout;
                  col.w = 4;
                  col.md = w;
                  col.sm = 6;
                  col.xs = 12;
                  col.children = [];
                  col.frameIndex = controlData.children[0].children[0].frameIndex;
                  rowElem.children.push(col);
                }
              }
              if (newSheet.children) newSheet.children.push(rowElem);
              else {
                newSheet.children = [];
                newSheet.children.push(rowElem);
              }
            } catch (error) {
              console.log(error);
            }
          }
          if (
            controlData.children !== undefined &&
            controlData.children !== null
          ) {
            controlData.children.push(newSheet);
          } else {
            controlData.children = [];
            controlData.children.push(newSheet);
          }
          
          updatedComponentInFormState(controlId, controlData);
          setOpenLoader(false);
        })
        .catch((err) => {
          setOpenLoader(false);
          window.loading(false)
        });
    // } else {
    //   functions.showMess(["Max",window?.psh_configs?.tabSheetCount,"Sheets_Allowed"],"error");
    // }
  };

  const handleDoubleClick = useCallback(
    debounce(
      (data) => {
        addSheet(data);
      },
      200,
      { leading: true, trailing: false, maxWait: 200 }
    ),
    []
  );

  const handleDoubleClick2 = useCallback(debounce((data) => {
    addStep(data);
    }, 200, {leading: true, trailing: false, maxWait: 200}), []);

const handleDoubleClick3 = useCallback(debounce((e,index,data) => {
  addSubStep(e,index,data);
    }, 200, {leading: true, trailing: false, maxWait: 200}), []);

const handleDoubleClickMenu = useCallback(
  debounce(
    (data) => {
      addMainMenu(data);
    },
    200,
    { leading: true, trailing: false, maxWait: 200 }
  ),
  []
);

  function addMainMenu(data) {
    let controlData = { ...data };
    const mainMenuMaxCount = parseInt(window?.psh_configs?.mainMenuMaxCount || 6);

    if (controlData?.children?.length === mainMenuMaxCount) {
      setAlertData({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        alertContentKey: `${t("Adding menu limit exceeded")} ${mainMenuMaxCount}`,
        boxStyle:true
      });
      return;
    }

    var frameIndex = data && data.frameIndex;
    var extraDetails = {};
    extraDetails.elem_type = "MainMenu";
    sendRequestForControl(frameIndex, "add", "step", extraDetails)
      .then((response) => {
        if (response.data.status === 0) {
          var newStep = response.data;
          newStep.stepName = newStep.id;
          setIsMenuSubMenuAdded((prev) => !prev);
          controlData.children.push(newStep);
          updatedComponentInFormState(controlData.id, controlData);
        } else if (response.data.status === 1) {
          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentKey: "Reopen_Form",
          });
        } else {
          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentKey: "Error in adding MainMenu",
          });
        }
        setOpenLoader(false);
      })
      .catch((err) => {
        setOpenLoader(false);
        window.loading(false)
      });
  }

  function handleIconForTab(iconName, iconFile, uploadindex) {
    let currControl = { ...selectedControl };
    const temp_style = style;
    temp_style["icon"] = { name: "", file: "" };
    temp_style["icon"]["name"] = iconName;
    temp_style["icon"]["file"] = iconFile;
    var jIcons = {};
    if (jsonIcons !== undefined) {
      jIcons = jsonIcons;
    } else {
      jIcons = {};
    }
    setjsonForIcons(jIcons);
    currControl.children[parseInt(uploadindex)].icon.name = iconName;
    currControl.children[parseInt(uploadindex)].icon.file = iconFile;

    if (selectedControl !== currControl) {
      setSelectedControl({ ...currControl });
    } else {
      // setSelectedControl(selectedControl);
      setSelectedControl( () => {return {...selectedControl} } )
    }

    updatedComponentInFormState(selectedControl.id, selectedControl);
  }

  const handleClose = (report_name) => {
    setOpen(false);
    if (report_name && typeof report_name === "string") {
      setFilter(report_name);
    }
  };

  function handleToggleTab(ref, field) {
    let currControl = { ...selectedControl };
    let value;
    if (ref.current) {
      if (ref.current.checked === true) {
        ref.current.checked = false;
        value = false;
      } else {
        ref.current.checked = true;
        value = true;
      }
    }
    currControl.style[field] = value + "";

    if (selectedControl !== currControl) {
      setSelectedControl({ ...currControl });
    } else {
      setSelectedControl( () => {return {...selectedControl} } )
    }

    updatedComponentInFormState(selectedControl.id, selectedControl);
  }

  function handleToggleTab1(ref, field) {
    let currControl = { ...selectedControl };
    let value;
    if (ref.current) {
      if (ref.current.checked === true) {
        ref.current.checked = false;
        value = false;
      } else {
        ref.current.checked = true;
        value = true;
      }
    }
    currControl.style[field] = `${value}`;
    if (selectedControl !== currControl) {
      setSelectedControl({ ...currControl });
    } else {
      setSelectedControl( () => {return {...selectedControl} } )
    }
    updatedComponentInFormState(selectedControl.id, selectedControl);
  }

  if (selectedControl.elem_type === "tab") {
    var htmlArray = [];
    var htmlArray2 = [];

    if (
      selectedControl.style &&
      selectedControl.style["AddIcon"] === undefined &&
      selectedControl.children
    ) {
      let currControl = { ...selectedControl };
      Object.values(selectedControl.children).map((key, index) => {
        if (key.icon && key.icon.file && key.icon.file !== "") {
          currControl.style["AddIcon"] = "true";
        }
      });
    }

    htmlArray.push(
      <div
      >
        <div style={{ flex: 1, display: "flex" }}>
          {t("translation:TabsLabels")}
          <div style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
            {t("translation:AddIcons")} &nbsp;
            <span>
              
              <ToggleBtnQuickTool
               
                field={"AddIcon"}
                handleToggleRef={setToggleValue}
                toggleState={selectedControl.style["AddIcon"] || ""}
              />
            </span>
          </div>
        </div>
        <div className={styles.sheetContainerWithIcons}>
          {props.selectedControl.children.map((key, ind) => {
            return (
              <>
                <div
                  className={
                    selectedControl.style["AddIcon"] === "true"
                      ? [styles.InputSheetBackgroundAfterAddIcon, styles.inputPaddingHeightTab].join(" ")
                      : [styles.InputSheetBackground,styles.inputPaddingHeightTab].join(" ")
                  }
                >
                  <input
                    id={key.id + "SheetNameInput"}
                    size={totalSheets > 1 ? "37" : "41"}
                    className={styles.TabLabelsInput}
                    key={key.id}
                    type="text"
                    defaultValue={key.tabChildName}
                    maxLength={window?.psh_configs?.label_max_length}
                    onBlur={() => updateSheetName(key.id)}
                  />
                  {totalSheets > 1 ? (
                    <span
                      className={[styles.deleteIconForTabSheetInput,styles.deleteIconForTabSheetInput2].join(" ")}
                      style={
                        translationStyles1
                          ? { right: "unset", left: "0.3em" }
                          : null
                      }
                      onClick={() => confirmDeletion(key.id, key.sheetIndex)}
                    >
                      <RedCross />
                    </span>
                  ) : null}
                  
                  {selectedControl.style["AddIcon"] === "true" ||
                  selectedControl.style["AddIcon"] === true ? (
                    <div
                      className={styles.TabIconUploadBtn}
                      key={ind}
                      sheetindex={ind}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      <ImageUploadBtn
                        containerId={props.containerId}
                        showIcon="true"
                        handleImageUpload={handleIconForTab}
                        iconName={
                          (selectedControl &&
                            selectedControl.style &&
                            selectedControl.children[ind]["icon"]["name"]) ||
                          ""
                        }
                        containerName = {props.selectedControl.elem_type}
                        uploadindex={ind}
                      />
                    </div>
                  ) : null}
                </div>
              </>
            );
          })}
        </div>

        <div>
          <button
            className={styles.AddTabButton}
            id="addButtonCommonStyle"
            onClick={() => handleDoubleClick(props.selectedControl)}
            onMouseOver={() => setIsButtonHover(true)}
            onMouseLeave={() => setIsButtonHover(false)}
          >
            <PlusBlue color={isButtonHover ? "#FFFFFF" : "#0072c6"} /> &nbsp;
            &nbsp; {t("Add Tab")}
          </button>
        </div>
      </div>
    );

    

    Items.push(htmlArray);
  }

  if (selectedControl.elem_type === "Menu") {
    var htmlArray = [];
    var htmlArray2 = [];

    if (
      selectedControl.style &&
      selectedControl.style["showIcons"] === undefined &&
      selectedControl.children
    ) {
      let currControl = { ...selectedControl };
      Object.values(selectedControl.children).map((key, index) => {
        if (key.icon && key.icon.file && key.icon.file !== "") {
          currControl.style["showIcons"] = "true";
          
        }
      });
      
    }

    htmlArray.push(
      <div
      >
        <div style={{ flex: 1, display: "flex", marginBottom: "6px" }}>
          <div
            style={{
              flex: 1,
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "-7px",
            }}
          >
            {t(`translation:Add Icons`)} &nbsp;
            <span>
              
              <ToggleBtnQuickTool
                handleToggleRef={handleToggle}
                field={"showIcons"}
                toggleState={selectedControl?.style?.["showIcons"] + "" || ""}
              />
            </span>
          </div>
        </div>

        <div className={styles.sheetContainerWithIcons}>
          {selectedControl?.children?.map((key, ind) => {
            return (
              <div
                className={
                  selectedControl.style["showIcons"] === "true"
                    ? styles.InputSheetBackgroundAfterAddIcon
                    : styles.InputSheetBackground
                }
                style={{
                  height: "fit-content",
                  marginTop: "2%",
                  paddingTop: "5px",
                  marginBottom: "0%",
                }}
                key={key.stepName}
              >
                <span
                  style={{
                    marginTop: "-36%",
                    color: "#2274bc",
                    fontWeight: "600",
                    paddingTop: "10%",
                    marginLeft: "9%",
                    position: "relative",
                    bottom: "-7%",
                  }}
                >
                  {t(`translation:${"MenuLabel"}`)}
                  {ind + 1}
                </span>

                <div style={{ padding: "5% 0% 0% 6%", position: "relative" }}>
                  <Svgdrag
                    className={"dragIcon6dot"}
                    color={"#afafaf"}
                    quickpropmenu={"quickpropmenu"}
                  />

                  <input
                    aria-label={"Step Name"}
                    id={key.id + "stepName"}
                    size={totalSheets > 1 ? "37" : "41"}
                    className={classes.test}
                    key={key.id + key.stepName}
                    defaultValue={key.stepName}
                    onBlur={() => updateStepName(key.id)}
                    style={{
                      width: "94%",
                      padding: "2% !important",
                      marginLeft: "3%",
                    }}
                  />

                  {totalSheets > 1 ? (
                    <span
                      className={styles.deleteIconForTabSheetInput}
                      onClick={() => deleteMainMenu(key.id, ind)}
                      style={
                        {
                          top: "17px",
                          ...(translationStyles1
                            ? { right: "unset", left: "35px" }
                            : { left: "unset", right: "15px" }
                          )
                        }
                      }
                    >
                      <RedCross />
                    </span>
                  ) : null}
                </div>

                {selectedControl.style["showIcons"] === "true" && (
                  <div
                    className={styles.TabIconUploadBtn}
                    key={ind}
                    sheetindex={ind}
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    style={{ margin: "11px", width: "84%", marginLeft: "9.5%" }}
                  >
                    <ImageUploadBtn
                      containerId={props.containerId}
                      showIcon="true"
                      handleImageUpload={handleIconForTab}
                      iconName={
                        selectedControl?.children?.[ind]?.["icon"]?.["name"] ||
                        ""
                      }
                      uploadindex={ind}
                    />
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div
          style={{
            marginTop: "4%",
            marginBottom: "1%",
            paddingLeft: translationStyles1 ? "20px" : null,
          }}
        >
          <button
            className={styles.AddTabButton + " qtwidebutton"}
            onClick={() => handleDoubleClickMenu(props.selectedControl)}
            style={{
              height: "100% !important",
              margin: "0 !important",
              width: "100% !important",
            }}
          >
            <PlusBlue marginBottom="4px" /> &nbsp;{" "}
            {t(`translation:AddMenuLabel`)}
          </button>
        </div>
      </div>
    );

    Items.push(htmlArray);
  }

  if (
    selectedControl.elem_type &&
    selectedControl.elem_type !== null &&
    selectedControl.elem_type !== undefined
  ) {
    if (
      (selectedControl.elem_type === "textarea" ||
        selectedControl.elem_type === "richtexteditor") &&
      selectedControl.controlName === "richtexteditor"
    ) {
      Object.keys(properties["richtext"]).forEach((property) => {
        const fetchedProperty = property.replace(/\d+/g, "");
        Items.push(
          returnHtml(
            fetchedProperty,
            properties["richtext"][property],
            ControlsMap[fetchedProperty].type
          )
        );
      });
    }
    else if(selectedControl.elem_type === "captcha") {
      Object.keys(properties["captcha"]).forEach((property) => {
        const fetchedProperty = property.replace(/\d+/g, "");
        Items.push(
          returnHtml(
            fetchedProperty,
            properties["captcha"][property],
            ControlsMap[property].type
          )
        );
      });
    } 
    else if (
      ((selectedControl.elem_type &&
      properties[selectedControl.elem_type]) || (selectedControl.ControlType &&
        properties[selectedControl.ControlType]))
    ) {
      if (selectedControl.elem_type === "advancelistview") {
        selectedControl.elem_type = "advancelistView";
      }
      if(selectedControl.ControlType === "slider") {
        Object.keys(properties[selectedControl.ControlType]).forEach((property) => {
          const fetchedProperty = property.replace(/\d+/g, "");
          Items.push(
            returnHtml(
              fetchedProperty,
              properties[selectedControl.ControlType][property],
              ControlsMap[fetchedProperty].type
            )
          );
        });
      }
      else {
        Object.keys(properties[selectedControl.elem_type]).forEach((property) => {
          const fetchedProperty = property.replace(/\d+/g, "");
          Items.push(
            returnHtml(
              fetchedProperty,
              properties[selectedControl.elem_type][property],
              ControlsMap[fetchedProperty].type
            )
          );
        });
      }
    }
  }
  useEffect(()=>{
    document.getElementById("backdropDiv")?.focus();
    
   },[])
  function handleEscapeKey(e) {
    if (e.code === "Escape" && props.open === true) {
      props.setOpen(false);
      setOpenQuickToolFor(undefined);
    }
  }

  const quickToolRef = useRef(null);

  function handleCancel(e,type) {
    if((quickToolRef.current && !quickToolRef.current.contains(e.target) && type === "clickAway") || type === "Cancel") {
      try {
        if (selectedControl && currCtrl)
          if (selectedControl.elem_type)
            if (
              selectedControl.elem_type === "wizard_h" ||
              selectedControl.elem_type === "wizard_v" ||
              selectedControl.elem_type === "sidenavigation"
            )
              setSelectedControlVar(currCtrl);
  
        if (selectedControl.elem_type === "doclist") {
          dispatch(updateStateInRedux({name: "doclistRerenderCount", value: new Date(),key: props.containerId}));
        }
  
        props.setOpen(false);
        setOpenQuickToolFor(undefined);
        window.selectedControlId_function(selectedControlCLone, selectedControl.id);
        Object.assign(props.selectedControl, {});
        Object.assign(props.selectedControl, selectedControlCLone);
  
        if(selectedControl.elem_type === "Menu" ||
          selectedControl.elem_type === "wizard_h" ||
          selectedControl.elem_type === "wizard_v" ||
          selectedControl.elem_type === "sidenavigation" ||
          selectedControl.elem_type === "tab"
        ) {
          populateFormStateFromJsonOnAction(JSON.stringify(formstateCLone), "yes");
        }
  
        if(
          props?.selectedControl?.elem_type === "slider" ||
          props?.selectedControl?.elem_type === "toggle" ||
          props?.selectedControl?.elem_type === "tile" ||
          props?.selectedControl?.controlName === "doclist"
        )
        updatedComponentInFormState(props.selectedControl.id,props.selectedControl,undefined,false);
        else{
          updatedComponentInFormState(
            undefined,
            undefined,
            undefined,
            false
          );
        }
  
      } catch (e) {
        console.error(e);
      }
    }

    // window.changeDrawer("open");
    if( window.selectedMenuItemNameState_leftpane==="Common Fields" ){
          document.querySelectorAll("#iforms_leftNav_sideBySide div[class*=LeftNavigation_menuItemsContainer] button")?.[0]?.click();
    }
    else if( window.selectedMenuItemNameState_leftpane==="Controls" ){
      document.querySelectorAll("#iforms_leftNav_sideBySide div[class*=LeftNavigation_menuItemsContainer] button")?.[1]?.click();
    }
    
    else if( window.selectedMenuItemNameState_leftpane==="Data Objects" ){
      document.querySelectorAll("#iforms_leftNav_sideBySide div[class*=LeftNavigation_menuItemsContainer] button")?.[2]?.click();
    }
    
    else if( window.selectedMenuItemNameState_leftpane==="Templates" ){
      document.querySelectorAll("#iforms_leftNav_sideBySide div[class*=LeftNavigation_menuItemsContainer] button")?.[3]?.click();
    }
    else{
      document.querySelector("#iforms_leftNav_sideBySide div[class*=LeftNavigation_menuItemsContainer] button")?.click();
    }
  //   window.callSpecifiedFunctions(
  //     { },
  //     "",
  //     "",
  //     true  
  // );
  }

  function handleView(isAddColumnClicked) {
    var newControl;
    if (currCtrl.elem_type === "CustomControl" && currCtrl.controlName !== "slider") {
        newControl = { ...currCtrl, elem_type: currCtrl.controlName };
    } else {
      newControl = currCtrl;
    }
    window.selectedControlId_function(newControl, newControl.id);
    setSelectedControlVar(newControl);
    setOpenPropertiesVar(true);
    props.setOpen(false);
    setOpenQuickToolFor(undefined);
  }

  function handleDone() {
    try {
      if (selectedControl && currCtrl)
        if (selectedControl.elem_type)
          if (
            selectedControl.elem_type === "wizard_h" ||
            selectedControl.elem_type === "wizard_v" ||
            selectedControl.elem_type === "sidenavigation"
          ) {
            setSelectedControlVar(currCtrl);
          }
      
      props.setOpen(false);
      setOpenQuickToolFor(undefined);
      window.selectedControlId_function(selectedControl, selectedControl.id);
    } catch (e) {
      console.error(e);
    }
  //   window.callSpecifiedFunctions(
  //     { },
  //     "",
  //     "",
  //     true  
  // );
  }

  function getSelectedLayout(property, value) {
    changeSectionLayout(value, selectedControl);
  }

  function handleToggle(ref, field) {
    let currControl = { ...selectedControl };
    let value;
    if (ref.current) {
      if (ref.current.checked === true) {
        ref.current.checked = false;
        value = false;
      } else {
        ref.current.checked = true;
        value = true;
      }
    }

    let updatedControl = { ...selectedControl };
    if (field === "showSubsteps" && (value == "false" || value == false)) {
      setAlertData({
        open: true,
        showConfirm: "showconformationDialogBox",
        alertContentKey: "RemoveSubstepConfirmationContent",
        alertTitleKey: "RemoveSubstepConfirmationTitle",
        Button1Key: "No",
        Button2Key: "Yes",
        deleteSubmenus: deleteSubmenus
      });
      return;
    }
    if (field === "Enable") {
      updatedControl.style["previousEnable"] = value + "";
      if (
        updatedControl?.id.includes("frame") ||
        updatedControl?.id.includes("tab") ||
        updatedControl?.id.includes("wizard")
      )
        updatedControl = changeControlProperty(value, field, updatedControl);
    }
    if (field === "ReadOnlyStyle") {
      updatedControl.style["previousReadOnly"] = value + "";
      if (
        updatedControl?.id.includes("frame") ||
        updatedControl?.id.includes("tab") ||
        updatedControl?.id.includes("wizard")
      )
        updatedControl = changeControlProperty(value, field, updatedControl);
    }

    if (field === "ReadOnly") {
      updatedControl.style["previousReadOnlyValue"] = value + "";
      if (
        updatedControl?.id.includes("frame") ||
        updatedControl?.id.includes("tab") ||
        updatedControl?.id.includes("wizard")
      )
        updatedControl = changeControlProperty(value, field, updatedControl);
    }

    updatedControl.style[field] = value + "";

    if (selectedControl !== updatedControl) {
      setSelectedControl({ ...updatedControl });
    } else {
      setSelectedControl(updatedControl);
    }

    updatedComponentInFormState(updatedControl.id, updatedControl);
  }

  function handleToggleWithEvent(e, field, check) {
    let value;

    if (check === "toggle") {
      value = !(e.target ? e.target.value : e.current.checked);
    } else {
      value = e.target.value;
    }

    let currControl = { ...selectedControl };
    let updatedControl = { ...selectedControl };
    updatedControl.style[field] = value;
    props.selectedControl.style[field] = value + "";

    if (field === "Enable") {
      updatedControl.style["previousEnable"] = value + "";
      if (
        updatedControl?.id.includes("frame") ||
        updatedControl?.id.includes("tab")
      )
        updatedControl = changeControlProperty(value, field, updatedControl);
    }
    if (field === "ReadOnlyStyle") {
      updatedControl.style["previousReadOnly"] = value + "";
      if (
        updatedControl?.id.includes("frame") ||
        updatedControl?.id.includes("tab") ||
        updatedControl?.id.includes("wizard")
      )
        updatedControl = changeControlProperty(value, field, updatedControl);
    }
    if (field === "ReadOnly") {
      updatedControl.style["previousReadOnlyValue"] = value + "";
      if (
        updatedControl?.id.includes("tab") ||
        updatedControl?.elem_type === "Menu"
      )
        updatedControl = changeControlProperty(value, field, updatedControl);
    }

    // if (selectedControl !== updatedControl) {
    //   setSelectedControl({ ...updatedControl });
    // } else {
      setSelectedControl({ ...updatedControl });
    // }

    updatedComponentInFormState(updatedControl.id, updatedControl);
  }

  function validateRegex(propertyName, propertyValue, event, inputBoxId) {
    let currControl = { ...selectedControl };
    try {
      let passValue=event?.key;
      if(propertyName==="CustomId"){
        if (
          event &&
          event.which !== 8 &&
          event.which !== 46 &&
          event.code !== "Tab" &&
          !regexValidator(
            propertyValue,
            ControlsMap[propertyName]["regexType"]
          )
        ) {
          event.preventDefault();
          setAlertData({
            ...ControlsMap["customizedAlertNotificationData"],
            open: true,
            alertContentKey: "RegexErrorMessage",
          });
        } else {
          setCustomId(propertyValue);
          setErrorMessageId(false);
        }
      }
      else
      {
        if (
        event &&
        event.which !== 8 &&
        event.which !== 46 &&
        event.code !== "Tab" &&
        !regexValidator(
          passValue,
          ControlsMap[propertyName]["regexType"]
        )
      ) {
        event.preventDefault();

        setAlertData({
          ...ControlsMap["customizedAlertNotificationData"],
          open: true,
          alertContentKey: "RegexErrorMessage",
        });
      } else {
        if (propertyName === "UserDefinedID") {
          currControl.style["CustomId"] = propertyValue;
        }
        if (selectedControl !== currControl) {
          setSelectedControl({ ...currControl });
        } else {
          setSelectedControl({ ...selectedControl });
        }
        setAlertData({
          showConfirm: "showNotification",
          open: false,          
        });
        setErrorMessageId(false);
      }}
    } catch (e) {
      console.log("Error while validating regex");
    }
  }

  function handleSupProperty(propertyName, propertyValue, event, inputBoxId) {
    let currControl = { ...selectedControl };
    try {
      if (
        event &&
        event.which !== 8 &&
        event.which !== 46 &&
        !regexValidator(event.key, ControlsMap[propertyName]["regexType"])
      ) {
        event.preventDefault();
        setErrorMessageId(inputBoxId);
      } else {
        if (propertyName === "Label") {
          currControl[propertyName] = propertyValue;
        } else {
          currControl.style["Label"] = propertyValue;
        }
        if (selectedControl !== currControl) {
          setSelectedControl({ ...currControl });
        } else {
          setSelectedControl({ ...selectedControl });
        }
        updatedComponentInFormState(selectedControl.id, selectedControl);
        setErrorMessageId(false);
      }
    } catch (e) {
      console.log(e);
    }
  }

  function handleSubform(e, subformid, step, substep) {
    e.stopPropagation();
    if (step && substep) {
      props.selectedControl.children[step].children[substep].subformId =
        subformid;
    } else {
      props.selectedControl.children[step].subformId = subformid;
    }
    updatedComponentInFormState(props.selectedControl.id, {
      ...props.selectedControl,
    });
  }

  function handleProperty(propertyName, propertyValue, event) {
    if (
      props.selectedControl.elem_type === "label" ||
      props.selectedControl.elem_type === "link" || 
      props.selectedControl.controlName === "iframe"
    ) {
      if (propertyName === "Label" && !propertyValue) {
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: "label is required",
          autoHideDuration: 6000,
        });
        return;
      }
      if(propertyName === "SourceURL" && props.selectedControl.controlName === "iframe") {
        if( /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?\/[a-zA-Z0-9]{2,}|((https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?)|(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?/g.test(propertyValue)){
          props.selectedControl.style["SourceURL"] = propertyValue;  
        }
        else{
          setAlertData({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentMsg: "The URL is invalid. Please enter a valid URL.",
            autoHideDuration: 4000,
          });
          return;
        }
      }
    }

    if (propertyName == "DatePickerLabel" || propertyName == "CaptchaLabel") {
      propertyName = "Label";
    }

    if (propertyName == "HeightText") {
      propertyName = "Height";
    }
    if (propertyName === "CustomId") {
      if (propertyValue !== props.selectedControl.style.CustomId) {
        var element = event.target;
        var jsonToSend = {
          customControlId: propertyValue,
          controlid: props.selectedControl.id,
          isSubForm: props?.selectedControl?.isSubForm,
          isAdvanceListview: props?.selectedControl?.isAdvanceListview,
          type:formState2?.containerControl ? "menu":null
        };
        validateCustomControlId(jsonToSend)
          .then((response) => {
            if (response && response.data && response.data.status === "0") {
              let temp_style = props.selectedControl.style;
              
              let updatedJson = updateUserId(
                props.selectedControl, // whole control Json
                propertyValue //newly defined id
                
              );
              if (updatedJson) {
                updatedComponentInFormState(
                  props.selectedControl.id,
                  updatedJson
                );
              }
            } else if (
              response &&
              response.data &&
              response.data.status === "-1"
            ) {
              //customalert
              showAlertConfirmNotifications({
                open: true,
                showConfirm: "showNotification",
                alertType: "error",
                alertContentKey: "CUSTOMCONTROL_EXIST",
              });
              element.value = props.selectedControl.style.CustomId || "";
            }
          })
          .catch(function (error) {
            element.value = props.selectedControl.style.CustomId || "";
            console.log("Server side error " + error);

          });
      }
    } else if (propertyName === "UploadOption") {
      handleToggleWithEvent({ target: { value: propertyValue } }, propertyName);
    } else {
      let temp_style = props.selectedControl.style;
      temp_style[propertyName] = propertyValue;
      if (propertyName === "ControlStyle" && propertyValue === "Style3") {
        props.selectedControl.style["LabelInputAlignment"] = "1";
      }

      if (
        props.selectedControl.elem_type === "doclist" &&
        propertyName === "Label"
      ) {
        propertyName = "DocumentLabel";
        props.selectedControl.style["Label"] = propertyValue;
        dispatch(updateStateInRedux({name: "doclistRerenderCount", value: new Date(),key: props.containerId}));
      }

      props.selectedControl.style[propertyName] = propertyValue;
      updatedComponentInFormState(
        props.selectedControl.id,
        props.selectedControl
      );
      
    }
  }

  function handleCustomIdPaste(propertyName, event, inputBoxId){
          const pastedText = event.clipboardData.getData('text');
          if (!regexValidator(pastedText, ControlsMap[propertyName]["regexType"])) {
            event.preventDefault();
            setErrorMessageId(inputBoxId);
            setAlertData({
              ...ControlsMap["customizedAlertNotificationData"],
              open: true,
              alertContentKey: "RegexErrorMessage",
            });
            event.target.value = '';
          }
        }

 
  function handleIcon(iconName, iconFile) {
    let currControl = { ...selectedControl };
    if (currControl.elem_type === "button") {
      currControl.style["icon"] = { name: "", file: "" };
      currControl.style["icon"]["name"] = iconName;
      currControl.style["icon"]["file"] = iconFile;
      currControl.style["iconName"] = iconName;
      currControl.style["iconFile"] = iconFile;
    }
    if (
      currControl.elem_type === "imagecarousel" &&
      !currControl.style["imageList"]
    ) {
      currControl.style["imageList"] = [];
    }
    if (
      currControl.elem_type === "imagecarousel" &&
      iconName !== "" &&
      iconFile !== ""
    ) {
      currControl.style["imageList"].push({
        imageName: iconName,
        imageFile: iconFile,
      });
    }
    if (currControl.elem_type == "image" || currControl.elem_type === "frame") {
      currControl.style["iconName"] = iconName;
      currControl.style["iconFile"] = iconFile;
    }

    if (currControl.elem_type === "textbox") {
      currControl.style["icon"] = { name: "", file: "" };
      currControl.style["icon"]["name"] = iconName;
      currControl.style["icon"]["file"] = iconFile;
      currControl.style["iconName"] = iconName;
      currControl.style["iconFile"] = iconFile;
    }
    if (currControl.elem_type === "combo") {
      currControl.style["icon"] = { name: "", file: "" };
      currControl.style["icon"]["name"] = iconName;
      currControl.style["icon"]["file"] = iconFile;
      currControl.style["iconName"] = iconName;
      currControl.style["iconFile"] = iconFile;
    }
    if (currControl.elem_type === "listbox") {
      currControl.style["icon"] = { name: "", file: "" };
      currControl.style["icon"]["name"] = iconName;
      currControl.style["icon"]["file"] = iconFile;
      currControl.style["iconName"] = iconName;
      currControl.style["iconFile"] = iconFile;
    }
    if (currControl.elem_type === "picklist") {
      currControl.style["icon"] = { name: "", file: "" };
      currControl.style["icon"]["name"] = iconName;
      currControl.style["icon"]["file"] = iconFile;
      currControl.style["iconName"] = iconName;
      currControl.style["iconFile"] = iconFile;
    }

    if (selectedControl !== currControl) {
      setSelectedControl({ ...currControl });
    } else {
      setSelectedControl({ ...selectedControl });
    }
    updatedComponentInFormState(currControl.id, currControl);
  }

  function showImageAlert(uploadType) {
    showAlertConfirmNotifications({
      open: true,
      showConfirm: "showNotification",
      alertType: "success",
      alertContentKey: uploadType
        ? "IMAGE_UPLOADED_SUCCESSFULLY"
        : "UPLOAD_SUCCESSFULLY",
    });

    // window.setTimeout(() => {
    //   showAlertConfirmNotifications({
    //     open: false,
    //     showConfirm: "showNotification",
    //     alertType: "success",
    //     alertContentKey: uploadType
    //       ? "IMAGE_UPLOADED_SUCCESSFULLY"
    //       : "UPLOAD_SUCCESSFULLY",
    //   });
    // }, 1000);
  }

  function handleIconForWizard(iconName, iconFile, index, uploadType) {
    let currControl = props.selectedControl;
    const stepJson = props.selectedControl.children[index];
    stepJson.icon.name = iconName;
    stepJson.icon.file = iconFile;
    currControl.children[index] = stepJson;
    props.selectedControl.children[index] = stepJson;

    if (selectedControl !== currControl) {
      setSelectedControl({ ...currControl });
    } else {
      setSelectedControl({ ...selectedControl });
    }
    if (iconName && iconFile) {
      showImageAlert(uploadType);
    }

    updatedComponentInFormState(
      props.selectedControl.id,
      props.selectedControl
    );
  }

  const handleOpen = () => {
    setOpen(true);
  };

  function selectedOptionForLabel(
    selectedControlId,
    selectedControlLabel,
    ControlLabelKey
  ) {
    let currControl = { ...selectedControl };
    const select = document.getElementById(selectedControlId + ControlLabelKey);
    const option_tag = select.options[select.selectedIndex];

    let temp_style = currControl.style;
    temp_style[ControlLabelKey] = option_tag.value;
    currControl.style[ControlLabelKey] = option_tag.value;

    if (selectedControl !== currControl) {
      setSelectedControl({ ...currControl });
    } else {
      setSelectedControl({ ...selectedControl });
    }

    updatedComponentInFormState(currControl.id, currControl);
  }

  function setColumnDetails() {
    let currControl = { ...selectedControl };
    if (props && currControl && currControl.columnList) {
      var temp_existingColumns = existingColumnsIndex
        ? existingColumnsIndex
        : [];
      var columnNames = [];
      try {
        currControl.columnList.map((column) => {
          if (!existingColumnsIndex) {
            temp_existingColumns.push(column.columnIndex);
          } else if (
            existingColumnsIndex &&
            Array.isArray(existingColumnsIndex) &&
            !existingColumnsIndex.includes(column.columnIndex)
          ) {
            temp_existingColumns.push(column.columnIndex);
          }
          columnNames.push(column.style["ColumnName"]);
        });
        setExistingColumnsIndex(temp_existingColumns);
        setColumnNamesList(columnNames);
      } catch (e) {
        console.log("Collecting existing columns" + e);
      }
    }
    if (props && currControl && currControl.columnList) {
      var temp_columnsStyle = columnsStyle ? columnsStyle : {};
      try {
        currControl.columnList.map((column) => {
          if (!columnsStyle) {
            temp_columnsStyle[column.columnIndex] = column;
          }
          else if (
            columnsStyle &&
            columnsStyle !== null &&
            typeof columnsStyle === "object" &&
            !Object.keys(columnsStyle).includes(column.columnIndex + "")
          ) {
            temp_columnsStyle[column.columnIndex] = column;
          }
        });
        setColumnsStyle(temp_columnsStyle);
        return true;
      } catch (e) {
        console.log("Collecting existing columns" + e);
      }
    }
    return false;
  }

  function handleBackdrop(arg, columnId) {
    var currControl = { ...selectedControl };
    if (arg === true) {
      var status = setColumnDetails();
      currControl.columnList.map((obj, index) => {
        if (columnId === obj.columnIndex) {
          setSelectedColumn(obj);
          setSelectedColumnIndex(obj.columnIndex);
          if (
            status === true &&
            existingColumnsIndex &&
            existingColumnsIndex !== null &&
            columnsStyle &&
            columnsStyle !== null
          ) {
            setShowTableBackdrop(arg);
          }
        }
      });
    } else if (arg === false) {
      setShowTableBackdrop(arg);
    }
  }

  function addColumn() {
    let currControl = { ...selectedControl };
    setIsTableBackdropOpen(true);
    try {
      setColumnDetails();
      const column = {};
      column.frameIndex = currControl.frameIndex;
      column.columnIndex = createUniqueId("temp_tableColumn");
      column.elementIndex = currControl.elementIndex;
      column.style = Object.assign({}, ThemeJSON.tableColumn1);
      column.style["ColumnName"] = "";

      column.style["EnableSearch"] =
        props?.selectedControl?.isAdvanceListview &&
        (props?.selectedControl?.elem_type === "table" || props?.selectedControl?.elem_type === "listview")
          ? "false"
          : "true";

      column.from = "new";
      column.existingColumn = false;
      column.from = "add";
      setSelectedColumn(column);

      window.selectedControlId_function(selectedControl, selectedControl.id);

      handleView();
      setTimeout(() => {
        document.getElementById("gridAddColumn")?.click();
      }, 500);

    } catch (e) {
      console.log(e);
    }
  }

  const containsSubsteps = (json, find) =>{
    const findKey=find?.toLowerCase();
    return json?.children?.findIndex(function(child){return child?.elem_type?.toLowerCase()=== findKey })!==-1
  }

  function addStep(data) {
    setShouldShowLoader(false);
    let currControl = { ...data };
    var controlData = data;
    var frameIndex = currControl && currControl.frameIndex;
    var extraDetails={"callSource":"properties"};

    if (currControl && currControl.elementIndex) {
      extraDetails.elementIndex = currControl.elementIndex;
    }
    sendRequestForControl(frameIndex, "add", "step", extraDetails)
      .then((response) => {
        var newStep = response.data;
        newStep.stepName = newStep.id;
        controlData.children.push(newStep);
        updatedComponentInFormState(controlData.id, controlData);
        setOpenLoader(false);
        document
          .querySelector(
            `.stepssubsteps_parent_wizard .stepssubstepsMain.stepssubstepsMain${newStep.id}`
          )
          ?.scrollIntoView({ block: 'nearest'})();
      })
      .catch((err) => {
        setOpenLoader(false);
        window.loading(false)
      });
  }

  var wiz_max_substeps = props.selectedControl.elem_type === "wizard_h" ? window?.psh_configs?.wiz_max_substeps_wiz_h : window?.psh_configs?.wiz_max_substeps ;

  function addSubStep(e, index,data) {
  if( containsSubsteps(data.children[index],"substep") && data.children[index]?.children?.length===wiz_max_substeps ){
      setAlertData({
          'open':true,
          'showConfirm':'showNotification',
          'alertType':'error',
          'alertContentKey':`${t("Cannot add more than")} ${wiz_max_substeps} ${t("substeps")}`,
          'alertTitleKey':`More substeps cannot be added`
      }) 
  }
  else if( ( containsSubsteps(data.children[index],"substep") && data.children[index]?.children?.length<=wiz_max_substeps ) || data.children[index]?.children?.length===0){
    e.stopPropagation();
    var controlData = data.children[index];
    var frameIndex = selectedControl && selectedControl.frameIndex;
    var extraDetails={"callSource":"properties"};
    if (data && data.elementIndex) {
      extraDetails.elementIndex = data.elementIndex;
    }
    sendRequestForControl(index, "add", "addSubStep", extraDetails)
      .then((response) => {
        var newSubstep = response.data;
        const tempControl = cloneDeep(controlData);
        newSubstep.substepName = newSubstep.id;
        controlData.children.push(newSubstep);
        if(tempControl.children.length === 0) {
          // window.changeIndex(tempControl.id,newSubstep.id,'0');
          data.setIndex = {
            stepIndex: index,
            stepId: data?.children?.[index]?.id,
            subStepIndex: '0',
            subStepId: newSubstep.id
          }
        }
        updatedComponentInFormState(data.id, data);
        setOpenLoader(false);
      })
      .catch((err) => {
        setOpenLoader(false);
        window.loading(false)
      });
  }
  }

  function deleteStep(stepDetails, stepIndex) {
    setShouldShowLoader(false);
    var currControl = props.selectedControl;
    if (currControl.children.length > 1) {
      var frameIndex = currControl && currControl.frameIndex;
      var extraDetails = {};
      sendRequestForControl(frameIndex, "delete", "step", {
        stepIndex: stepIndex,
        id: stepDetails,
      })
        .then((response) => {
          currControl.children.splice(stepIndex, 1);
          updatedComponentInFormState(currControl.id, currControl);
          setOpenLoader(false);
        })
        .catch((err) => {
          setOpenLoader(false);
          window.loading(false)
        });
    } else if (currControl.children.length === 1) {
      setAlertData({
        open: true,
        alertContentMsg: `${t("translation:Last_step_cannot_be_deleted")}`,
        showConfirm: "showNotification",
        alertType: "error",
        autoHideDuration: 6000,
      });
    }
  }

  async function deleteSubmenus() {
    var frameIndex = props.selectedControl && props.selectedControl.frameIndex;
    for(let i = 0; i < props?.selectedControl?.children?.length; i++) {            
        if(containsSubsteps(props?.selectedControl?.children[i],"substep")) {
            try {
                for(let j = 0; j < props?.selectedControl?.children[i]?.children.length; j ++) {
                    const response = await sendRequestForControl( frameIndex, 'delete', "subStep", {"stepIndex":i,"subStepIndex":j, "subChildMenuIndex" : "-1", "id": props?.selectedControl?.children[i]?.children[j]?.id })
                    if(response.data.status === 0) {
                      setOpenLoader(false);
                    }
                }
                props.selectedControl.children[i].children = [];
            }
            catch(err){
                console.log(err);
                setOpenLoader(false);
            } 
        }
    }
    props.selectedControl.style["showSubsteps"] = "false";
    updatedComponentInFormState(props.selectedControl.id, props.selectedControl);
}

  function deleteSubStep(subStepDetails, stepIndex, subStepIndex) {
    var controlData = props.selectedControl;
    var frameIndex = props.selectedControl && props.selectedControl.frameIndex;
    sendRequestForControl( frameIndex, 'delete', "subStep", {"stepIndex":stepIndex,"subStepIndex":subStepIndex, "subChildMenuIndex" : "-1", "id": subStepDetails.id}).then((res) => {
      if(res.data.status === 0) {
        const length = controlData.children[stepIndex].children?.length;
        controlData.children[stepIndex].children.splice(subStepIndex,1);
        for(let child of controlData.children[stepIndex].children) {
            if(subStepIndex < child.SubStepIndex) {
                updateStepIndex(child, child.SubStepIndex - 1,"subStepIndex");
                child.SubStepIndex = child.SubStepIndex - 1;
            }
          }
          if(controlData.children[stepIndex].children?.length === 0) 
            controlData.setIndex = {
                stepIndex: stepIndex,
                stepId: controlData?.children?.[stepIndex]?.id
            }
          else if(subStepIndex === length - 1)
            controlData.setIndex = {
              stepId: controlData?.children?.[stepIndex]?.id,
              stepIndex: stepIndex,
              subStepId: controlData?.children?.[stepIndex]?.children?.[0]?.id,
              subStepIndex: 0
            }
          else
            controlData.setIndex = {
              stepId: controlData?.children?.[stepIndex]?.id,
              stepIndex: stepIndex,
              subStepId: controlData?.children?.[stepIndex]?.children?.[subStepIndex]?.id,
              subStepIndex: subStepIndex
            }
          updatedComponentInFormState(controlData.id, {...controlData});
          setOpenLoader(false);
      }
    })
    .catch((err) => {
      console.log(err);
      setOpenLoader(false);
    })
  }

  function handleStep(e, stepIndex) {
    const { name, value } = e.target;
    var controlData = { ...selectedControl };
    if (controlData.children?.[stepIndex]?.[name]) {
      controlData.children[stepIndex][name] = value;
    }
    updatedComponentInFormState(controlData.id, controlData);
   
    if (selectedControl !== controlData) {
      setSelectedControl({ ...selectedControl, ...controlData });
    } else {
      setSelectedControl({ ...selectedControl });
    }
  }

  function handleSubStep(e, stepIndex, subStepIndex) {
    const { name, value } = e.target;
    var controlData = { ...selectedControl };
    controlData.children[stepIndex].children[subStepIndex][name] = value;
    if (selectedControl !== controlData) {
      setSelectedControl({ ...selectedControl, ...controlData });
    } else {
      setSelectedControl( () => {return {...selectedControl} } )
    }
  }

  function handleActiveStep(stepId) {
    if (stepId === activeStep) {
      setActiveStep("");
    } else {
      setActiveStep(stepId);
    }
  }

  let previousPosition;
  let newPosition;
  function allowDrop(event) {
    newPosition = event.target.attributes?.option_index?.value;
    let isParent = event.target.attributes?.option_parent;
    if (isParent) {
      event.target.classList.add("addBorder");
    }
    if (newPosition) newPosition = parseInt(newPosition);
    event.preventDefault();
  }

  function dragLeave(event) {
    let isParent = event.target.attributes?.option_parent;
    if (isParent) {
      if (event.target.classList.contains("addBorder")) {
        event.target.classList.remove("addBorder");
      }
    }
  }

  function registerOptionToReposition(event, optionIndex) {
    if (optionIndex) previousPosition = parseInt(optionIndex);
  }

  function repositionThisOption(event) {

    if (event.target.attributes?.option_index?.value) {
      newPosition = parseInt(event.target.attributes.option_index.value);
      if(props?.selectedControl?.elem_type === "wizard_h" || props?.selectedControl?.elem_type === "wizard_v" || props?.selectedControl?.elem_type === "sidenavigation")
        changeOptionIndex_steps(1,newPosition, false, false);
      else changeOptionIndex();
    }
    let isParent = event.target.attributes?.option_parent;
    if (isParent) {
      if (event.target.classList.contains("addBorder")) {
        event.target.classList.remove("addBorder");
      }
    }
    event.preventDefault();
  }

  function changeOptionIndex_steps(opType = 1, stepindex = newPosition, dropBetween=false,onTop=false) {
    if (
      props.selectedControl.children &&
      previousPosition !== undefined &&
      newPosition !== undefined &&
      previousPosition !== null &&
      newPosition !== null &&
      typeof previousPosition === "number" &&
      typeof newPosition === "number"
    ) {
    
      window.loading(true);
      const formId = getFormId();
      let controlid = "";
      controlid = props.selectedControl.children?.[stepindex]?.id;
      const jsonToSend = {
        oldPosition: previousPosition,
        newPosition,
        controlid,
        opType,
        onTop,
        formId: formId.toString(),
        swapping: (!dropBetween).toString()
      };
      axios
        .post("/idesign/reorderMenuPosition", jsonToSend, { withCredentials: true })
        .then((res) => {
          if (opType === 0) {
            if(dropBetween) {
              const child = props.selectedControl.children[previousPosition];
              if(onTop) {
                props.selectedControl.children.splice(previousPosition,1);
                props.selectedControl.children.unshift(child);                  
                for(let i = 0; props.selectedControl.children[i]; i++) {
                  updateStepIndex(props.selectedControl.children[i], i,"stepIndex");
                  props.selectedControl.children[i].StepIndex = i;
                }
              }
              else if(newPosition === props.selectedControl.children.length - 1) {
                props.selectedControl.children.splice(previousPosition,1);
                props.selectedControl.children.push(child);
                for(let i = 0; props.selectedControl.children[i]; i++) {
                  updateStepIndex(props.selectedControl.children[i], i,"stepIndex");
                  props.selectedControl.children[i].StepIndex = i;
                }
              } else {
                props.selectedControl.children.splice(newPosition + 1,0,child);
                if(previousPosition < newPosition) {
                  props.selectedControl.children.splice(previousPosition,1);
                } else {
                  props.selectedControl.children.splice(previousPosition+1,1);
                }
                for(let i = newPosition + 1; props.selectedControl.children[i]; i++) {
                  updateStepIndex(props.selectedControl.children[i], i,"stepIndex");
                  props.selectedControl.children[i].StepIndex = i;
                }
              }
              if(containsSubsteps(child,"substep"))
                props.selectedControl.setIndex = {
                  stepId: child.id,
                  stepIndex: newPosition,
                  subStepId: child.children[0].id,
                  subStepIndex: 0
                }
              else
                props.selectedControl.setIndex = {
                  stepId: child.id,
                  stepIndex: newPosition,
                }
              updatedComponentInFormState(props.selectedControl.id,props.selectedControl);
            }
            else {
              const child = props.selectedControl.children[previousPosition];
              const child2 = props.selectedControl.children[newPosition];
              const temp = props.selectedControl.children[previousPosition];
              props.selectedControl.children[previousPosition] = props.selectedControl.children[newPosition];
              props.selectedControl.children[newPosition] = temp;
              updateStepIndex(child, newPosition,"stepIndex");
              child.StepIndex = newPosition;
              updateStepIndex(child2, previousPosition,"stepIndex");
              child2.StepIndex = previousPosition;
              if(containsSubsteps(child,"substep"))
                props.selectedControl.setIndex = {
                  stepId: child.id,
                  stepIndex: newPosition,
                  subStepId: child.children[0].id,
                  subStepIndex: 0
                }
                else
                  props.selectedControl.setIndex = {
                    stepId: child.id,
                    stepIndex: newPosition,
                  }
              updatedComponentInFormState(props.selectedControl.id,props.selectedControl);
            }

          } else if (opType === 1) {
            if(dropBetween) {
              const child = props.selectedControl.children[stepindex].children[previousPosition];
              if(onTop) {
                props.selectedControl.children[stepindex].children.splice(previousPosition,1);
                props.selectedControl.children[stepindex].children.unshift(child);                  
                for(let i = 0; props.selectedControl.children[stepindex].children[i]; i++) {
                  updateStepIndex(props.selectedControl.children[stepindex].children[i], i,"subStepIndex");
                  props.selectedControl.children[stepindex].children[i].SubStepIndex = i;
                }
              }
              else if(newPosition === props.selectedControl.children[stepindex].children.length - 1) {
                props.selectedControl.children[stepindex].children.splice(previousPosition,1);
                props.selectedControl.children[stepindex].children.push(child);
                for(let i = 0; props.selectedControl.children[stepindex].children[i]; i++) {
                  updateStepIndex(props.selectedControl.children[stepindex].children[i], i,"subStepIndex");
                  props.selectedControl.children[stepindex].children[i].SubStepIndex = i;
                }
              } else {
                props.selectedControl.children[stepindex].children.splice(newPosition+1,0,child);
                if(previousPosition < newPosition) {
                  props.selectedControl.children[stepindex].children.splice(previousPosition,1);
                } else {
                  props.selectedControl.children[stepindex].children.splice(previousPosition+1,1);
                }
                for(let i = newPosition + 1; props.selectedControl.children[stepindex].children[i]; i++) {
                  updateStepIndex(props.selectedControl.children[stepindex].children[i], i,"subStepIndex");
                  props.selectedControl.children[stepindex].children[i].SubStepIndex = i;
                }
              }
              if(containsSubsteps(child,"substep"))
                  props.selectedControl.setIndex = {
                    stepId: child.id,
                    stepIndex: newPosition,
                    subStepId: child.children[0].id,
                    subStepIndex: 0
                  }
              else
                  props.selectedControl.setIndex = {
                    stepId: child.id,
                    stepIndex: newPosition,
                  }
              updatedComponentInFormState(props.selectedControl.id,props.selectedControl);
            } else {
              const child = props.selectedControl.children[stepindex].children[previousPosition];
              const child2 = props.selectedControl.children[stepindex].children[newPosition];
              const temp = props.selectedControl.children[stepindex].children[previousPosition];
              props.selectedControl.children[stepindex].children[previousPosition] = props.selectedControl.children[stepindex].children[newPosition];
              props.selectedControl.children[stepindex].children[newPosition] = temp;
              updateStepIndex(child, newPosition,"subStepIndex");
              child.SubStepIndex = newPosition;
              updateStepIndex(child2, previousPosition,"subStepIndex");
              child2.SubStepIndex = previousPosition;
              props.selectedControl.setIndex = {
                stepId: props.selectedControl.children[stepindex].id,
                stepIndex: stepindex,
                subStepId: child.id,
                subStepIndex: newPosition
              }
              updatedComponentInFormState(props.selectedControl.id,props.selectedControl);
            }
          }
          window.loading(false);
        })
        .catch((res) => {
          console.log(res);
          setAlertData({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentKey: `Something went wrong - ${res?.response?.data?.err_Msg}`
          });
          window.loading(false);
        });
    } else {
      console.error("Something wrong with indexes!");
    }
  }

  function changeOptionIndex() {
    if (
      props.selectedControl.children &&
      previousPosition !== undefined &&
      newPosition !== undefined &&
      previousPosition !== null &&
      newPosition !== null &&
      typeof previousPosition === "number" &&
      typeof newPosition === "number"
    ) {
      let options = [...props.selectedControl.children];
      let optionToReposition = options[previousPosition];
      options.splice(previousPosition, 1);
      options.splice(newPosition, 0, optionToReposition);
      let updatedControl = { ...props.selectedControl };
      updatedControl.children = options;
      updatedComponentInFormState(props.selectedControl.id, updatedControl);
      props.selectedControl.children = options;
    } else {
      console.error("Something wrong with indexes!");
    }
  }

  function handleNoIcon() {
    showAlertConfirmNotifications({
      open: true,
      showConfirm: "showNotification",
      alertType: "error",
      alertContentKey: "CANT_UPLOAD",
    });
    setTimeout(function () {
      $("#limitDiv").css("background-color", "red");
    }, 1);

  }

  function changeImage() {}

  function deleteImage(imageDetails, index) {
    let currControl = { ...selectedControl };
    try {
      var indexToBeDeleted = -1;
      currControl.style["imageList"].map((imgDetails, imgIndex) => {
        if (imgDetails.imageName === imageDetails.imageName)
          indexToBeDeleted = imgIndex;
      });
      if (indexToBeDeleted > -1) {
        currControl.style["imageList"].splice(indexToBeDeleted, 1);
        currControl.style["iconName"] = "";

        if (selectedControl !== currControl) {
          setSelectedControl({ ...currControl });
        } else {
         setSelectedControl( () => {return {...selectedControl} } )
        }
        updatedComponentInFormState(currControl.id, currControl);
      }
    } catch (e) {
      console.log(
        "Error occured while deleting image from image carousel list"
      );
    }
  }

  function allowImageDrop(event) {
    event.preventDefault();
  }

  function handleDrag(event) {
    setDraggedImagePosition(event.target.getAttribute("imagePosition"));
  }

  function handleDrop(event) {
    let currControl = { ...selectedControl };
    if (event === "undefined") {
      event.preventDefault();
    } else if (event.target.getAttribute("imagePosition")) {
      try {
        let targetPosition = event.target.getAttribute("imagePosition");
        let temp_imageDetails = currControl.style["imageList"];
        let draggedImage = temp_imageDetails[draggedImagePosition];
        temp_imageDetails[draggedImagePosition] =
          temp_imageDetails[targetPosition];
        temp_imageDetails[targetPosition] = draggedImage;
        currControl.style["imageList"] = temp_imageDetails;

        if (selectedControl !== currControl) {
          setSelectedControl({ ...selectedControl, ...currControl });
        } else {
       setSelectedControl( () => {return {...selectedControl} } )
        }
      } catch (e) {
        console.log("Interchanging image Positions");
      }
    }
  }

  function changeTileContentCheck(value) {
    // let currControl = { ...selectedControl };
    // if (currControl.style[value] === "true") {
    //   currControl.style[value] = "false";
    // } else {
    //   currControl.style[value] = "true";
    // }

    // if (selectedControl !== currControl) {
    //   setSelectedControl({ ...currControl });
    // } else {
    //   setSelectedControl(selectedControl);
    // }
    // updatedComponentInFormState(currControl.id, currControl);
    // setTimeout(() => {
    //   if (selectedControl !== currControl) {
    //     setSelectedControl({ ...currControl });
    //   } else {
    //     setSelectedControl(selectedControl);
    //   }
    // }, 100);
    let currControl = { ...selectedControl };

    currControl.style = { ...currControl.style };
    currControl.style[value] = currControl.style[value] === "true" ? "false" : "true";

    const hasChanged = JSON.stringify(selectedControl) !== JSON.stringify(currControl);

    if (hasChanged) {
      setSelectedControl(currControl);
      updatedComponentInFormState(currControl.id, currControl);

      setTimeout(() => {
        setSelectedControl(currControl);
      }, 100);
    } else {
    setSelectedControl( () => {return {...selectedControl} } )
    }
}

  function handleDataAddition(eventName) {
    // let currControl = { ...selectedControl };
    // currControl.style["TileSelectionType"] = eventName;
    // props.selectedControl.style["TileSelectionType"] = eventName;
    // if (selectedControl !== currControl) {
    //   setSelectedControl({ ...currControl });
    // } else {
    //   setSelectedControl(selectedControl);
    // }

    // updatedComponentInFormState(currControl.id, currControl);
    // setTimeout(() => {
    //   if (selectedControl !== currControl) {
    //     setSelectedControl({ ...currControl });
    //   } else {
    //     setSelectedControl(selectedControl);
    //   }
    // }, 100);
    setSelectedControl((prevControl) => {
      // Create new updated control based on previous state
      const currControl = {
        ...prevControl,
        style: {
          ...prevControl.style,
          TileSelectionType: eventName,
        },
      };

      // Update external prop copy safely if needed — but ideally avoid mutating props directly
      // If you must, consider calling a prop callback instead to update parent state

      // Compare prevControl and currControl — simple shallow check here, or just update anyway
      if (JSON.stringify(prevControl) !== JSON.stringify(currControl)) {
        // Update the component in form state
        updatedComponentInFormState(currControl.id, currControl);

        return currControl;
      }
      return prevControl;
    });

    // If you still want the delayed update after 100ms:
    setTimeout(() => {
      setSelectedControl((prevControl) => {
        const currControl = {
          ...prevControl,
          style: {
            ...prevControl.style,
            TileSelectionType: eventName,
          },
        };
        if (JSON.stringify(prevControl) !== JSON.stringify(currControl)) {
          updatedComponentInFormState(currControl.id, currControl);
          return currControl;
        }
        return prevControl;
      });
    }, 100);
  }


  function selectedOptionForLinkIcon(value) {
    // let currControl = { ...selectedControl };
    // currControl.style["OnClick"] = value;
    // if (selectedControl !== currControl) {
    //   setSelectedControl({ ...selectedControl, ...currControl });
    // } else {
    //   setSelectedControl(selectedControl);
    // }
     setSelectedControl((prevControl) => {
    const currControl = { ...prevControl, style: { ...prevControl.style, OnClick: value } };
    
    if (JSON.stringify(prevControl) !== JSON.stringify(currControl)) {
      return currControl;
    }
    return prevControl; 
  });
  }

  function handleStyleType(property, value) {
    handleProperty(property, value);
  }

  function mappingOpen() {
    setSelectedControlVar(currCtrl);
    window.selectedControlId_function(selectedControl, selectedControl.id);
    props.setOpen(false);
    setOpenPropertiesVar(true);
    setfromQuickProps(true);
    setMappingField(true);
    setOpenQuickToolFor(undefined);
  }
  

  function returnHtml(key, value, type) {
    switch (type.toLowerCase()) {
      case "toggle":
        return (
          <>
            
            <div key={value.label} className={classes.toggleBtn}>
              <div className={classes.toggleLabel}>
                {" "}
                {t(`translation:${value.label}`)}{" "}
              </div>
              <ToggleBtnQuickTool
                key={
                  props.selectedControl.id + props.selectedControl.style[key]
                }
                handleToggleRef={
                  selectedControl.elem_type == "tab"
                    ? handleToggleWithEvent
                    : handleToggle
                }
                id={
                  props?.selectedControl?.style?.CustomId
                    ? props?.selectedControl?.style?.CustomId
                    : props?.selectedControl?.id
                }
                field={value.field + ""}
                toggleState={
                  (selectedControl &&
                    selectedControl.style &&
                    selectedControl.style[value.field + ""]) ||
                  ""
                }
              />
            </div>
          </>
        );


      case "textarea":
        return (
          <div>
            <div className={classes.labelTextBox}>
              <div className={classes.label}>
                {" "}
                {t(`translation:${ControlsMap[key].label}`)}{" "}
              </div>
              <textarea
                aria-label={selectedControl.style[key]}
                rows="2"
                className={[
                  classes.textArea,
                  errorMessageId === selectedControl.id + key
                    ? styles.inputBoxErrorStyle
                    : null,
                ].join(" ")}
                defaultValue={
                  (selectedControl &&
                    selectedControl.style &&
                    selectedControl.style[key]) ||
                  key === "Label"
                    ? selectedControl.id
                    : ""
                }
                key={selectedControl.id}
                id={selectedControl.id + key}
                placeholder={key === "SpecialCharacter" ? "eg:@,!,&" : null}
                onKeyPress={(event) =>
                  validateRegex(
                    key,
                    event.target.value,
                    event,
                    selectedControl.id + key
                  )
                }
                onKeyUp={(event) =>
                  validateRegex(
                    key,
                    event.target.value,
                    event,
                    selectedControl.id + key
                  )
                }
                onBlur={(event) => handleProperty(key, event.target.value)}
              ></textarea>
            </div>
            {errorMessageId === selectedControl.id + key ? (
              <ErrorMessageComponent errorMessage="non-permissible value" />
            ) : null}
          </div>
        );

      case "textbox":
        return (
          <div>
            <div className={styles.leftLabelForTextBox}>
              <div className={styles.labelForLabel}>
                {t(`translation:${ControlsMap[key].label}`)}{" "}
              </div>
              <input
                aria-label={"Control Value1"}
                type="text"
                defaultValue={
                  props.selectedControl.style?.[key] ||
                  props?.selectedControl?.style?.[key] === ""
                    ? props?.selectedControl?.style?.[key]
                    : props.selectedControl.id
                }
                key={
                  props.selectedControl.id + props.selectedControl.style?.[key]
                }
                
                id={props.selectedControl.id + key}
                className={[
                  styles.textBoxLayoutForLable, styles.stylequickcombo,
                  errorMessageId === props.selectedControl.id + key
                    ? styles.inputBoxErrorStyle
                    : null,
                ].join(" ")}
                maxLength={
                  props.selectedControl.elem_type !== "checkbox" &&
                  props.selectedControl.elem_type !== "label"
                    ? window?.psh_configs?.label_max_length
                    : ""
                }
                onKeyPress={(event) =>
                  validateRegex(
                    key,
                    event.target.value,
                    event,
                    props.selectedControl.id + key
                  )
                }
                onKeyUp={(event) =>
                  validateRegex(
                    key,
                    event.target.value,
                    event,
                    props.selectedControl.id + key
                  )
                }
                onBlur={(event) =>
                  handleProperty(key, event.target.value, event)
                }
              />
            </div>
            {errorMessageId === props.selectedControl.id + key ? (
              <ErrorMessageComponent errorMessage="non-permissible value" />
            ) : null}
          </div>
        );

      case "retrycountbox":
        return (
          <div>
            <div className={styles.leftLabelForTextBox} style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
              <div className={styles.labelForLabel} style={{display: 'flex', alignItems: 'center'}}>
                {t(`translation:${ControlsMap[key].label}`)}{" "}
              </div>
              <input
                aria-label={"Control Value1"}
                type="text"
                defaultValue={
                  props.selectedControl.style?.[key] !== undefined
                    ? props.selectedControl.style?.[key]
                    : ""
                }
                style={{ width: "50%" }}
                key={
                  props.selectedControl.id + props.selectedControl.style?.[key]
                }
                
                id={props.selectedControl.id + key}
                className={[
                  styles.textBoxLayoutForLable,
                  errorMessageId === props.selectedControl.id + key
                    ? styles.inputBoxErrorStyle
                    : null,
                ].join(" ")}
                maxLength={
                  props.selectedControl.elem_type !== "checkbox" &&
                  props.selectedControl.elem_type !== "label"
                    ? window?.psh_configs?.label_max_length
                    : ""
                }
                onKeyPress={(event) =>
                  validateRegex(
                    key,
                    event.target.value,
                    event,
                    props.selectedControl.id + key
                  )
                }
                onKeyUp={(event) =>
                  validateRegex(
                    key,
                    event.target.value,
                    event,
                    props.selectedControl.id + key
                  )
                }
                onBlur={(event) =>
                  handleProperty(key, event.target.value, event)
                }
              />
            </div>
            {errorMessageId === props.selectedControl.id + key ? (
              <ErrorMessageComponent errorMessage="non-permissible value" />
            ) : null}
          </div>
        );

      case "button":
        return (
          <>
            {selectedControl.style.LabelIcon &&
              selectedControl.style.LabelIcon === "true" && (
                <div className="uploadbtn">
                  <ImageUploadBtn
                    containerId={props.containerId}
                    handleImageUpload={handleIcon}
                    iconName={selectedControl?.style?.iconName || ""}
                  />
                </div>
              )}
          </>
        );

      case "imageupload":
        return (
          <>
            {style.ComboType !== "checkBox" && (
              <div className={styles.parentDivTopBottom}>
                <div>
                  <span className={styles.topBottomLabel}>
                    {selectedControl.elem_type === "image"
                      ? t(`translation:Add Image`)
                      : t(`translation:${ControlsMap[key].label}`)}
                  </span>
                </div>
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <ImageUploadBtn
                    containerId={props.containerId}
                    selectedControl={selectedControl}
                    handleImageUpload={handleIcon}
                    iconName={selectedControl.style.iconName}
                  />
                </div>
              </div>
            )}
          </>
        );

      case "carouselupload":
        return (
          <div
            className={styles.parentDiv}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <p className={styles.propertiesHeader1} style={translationStyles1?{textAlign:"right"}:null}>{t("AddImage")}</p>
            {selectedControl &&
            selectedControl.style &&
            selectedControl.style["imageList"] &&
            selectedControl.style["imageList"].length >= 5 ? (
              <ImageUploadBtn
                containerId={props.containerId}
                selectedControl={selectedControl}
                handleImageUpload={handleNoIcon}
                iconName={
                  ""
                }
              />
            ) : (
              <ImageUploadBtn
                containerId={props.containerId}
                selectedControl={selectedControl}
                handleImageUpload={handleIcon}
                iconName={
                  (selectedControl &&
                    selectedControl.style &&
                    selectedControl.style.iconName) ||
                  ""
                }
              />
            )}
            <div id="limitDiv" className={styles.imageCarouselinfo}>
            {t(`translation:${ControlsMap[key].info}`)}
            </div>

            {selectedControl &&
            selectedControl.style &&
            selectedControl.style["imageList"] &&
            selectedControl.style["imageList"].length > 0
              ? selectedControl.style["imageList"].map(
                  (imageDetails, index) => {
                    if (imageDetails) {
                      return (
                        <div
                          className={styles.imageCarouselImageEditDelete}
                          id={"imageDetails_" + index}
                          imagePosition={index}
                          onDragOver={allowImageDrop}
                          onDrop={(event) => handleDrop(event)}
                        >
                          <div
                            className={styles.addImageImageCarousel}
                            imagePosition={index}
                            draggable="true"
                            onDragStart={(event) => handleDrag(event)}
                          >
                            <span
                              id={"image_" + index}
                              className={styles.imageCarouselSpan}
                              draggable="true"
                              imagePosition={index}
                              onClick={() => changeImage(imageDetails, index)}
                            >
                              <DragAdvListview />
                            </span>
                            <span
                              className={[
                                styles.imageCarouselSpan,
                                styles.imageCarouselImageFileName,
                              ].join(" ")}
                              draggable="true"
                              imagePosition={index}
                            >
                              {" "}
                              {imageDetails.imageName}{" "}
                            </span>
                            <span
                              id={"image_" + index}
                              className={[
                                styles.imageCarouselSpan,
                                styles.imageCarouselEditIcon,
                              ].join(" ")}
                              title={t(`translation:Edit`)}
                              onClick={() => handleOpenCrop(index)}
                            >
                              <SvgEditIcon />
                            </span>
                            <span
                              id={"image_" + index}
                              className={styles.imageCarouselSpan}
                              onClick={() => deleteImage(imageDetails, index)}
                            >
                              <RedCross />
                            </span>
                          </div>
                        </div>
                      );
                    }
                  }
                )
              : null}
          </div>
        );

      case "text_top_bottom":
        return (
          <Form.Group>
            <div>
              <span className={classes.topBottomLabel}>
                {t(`translation:${ControlsMap[key].label}`)}
              </span>
            </div>

            {key === "Mapping" ? (
              <>
                <div style={{ display: "flex" }}>
                  <input
                    aria-label={"Control Value2"}
                    type="text"
                    defaultValue={props.selectedControl.style[key]}
                    disabled
                    key={
                      props.selectedControl.id +
                      props.selectedControl.style[key]
                    }
                    id={props.selectedControl.id + key}
                    className={[
                      styles.fullWidthTextBox,
                      errorMessageId === props.selectedControl.id + key
                        ? styles.inputBoxErrorStyle
                        : null,
                    ].join(" ")}
                    onKeyPress={(event) =>
                      validateRegex(
                        key,
                        event.target.value,
                        event,
                        props.selectedControl.id + key
                      )
                    }
                    onKeyUp={(event) =>
                      validateRegex(
                        key,
                        event.target.value,
                        event,
                        props.selectedControl.id + key
                      )
                    }
                    onBlur={(event) =>
                      handleProperty(key, event.target.value, event)
                    }
                  />
                  <span
                    title={t("translation: View Data Objects")}
                    className={styles.mappingDotsIcon}
                    style={
                      translationStyles1
                        ? { borderLeft: "1px solid #C4C4C4" }
                        : null
                    }
                    onClick={() => mappingOpen()}
                  >
                    <DOTS />
                  </span>
                </div>
              </>
            ) : 
            key=== "CustomId" ?
            <>
                <div>
                  <input
                 
                    aria-label={"Control Value4"}
                    type="text"
                    key={selectedControl.id}
                    id={selectedControl.id + key}
                    className={[
                      classes.fullWidthTextBox,
                      errorMessageId === selectedControl.id + key
                        ? styles.inputBoxErrorStyle
                        : null,
                    ].join(" ")}
                                  onChange={(event) =>
                      validateRegex(
                        key,
                        event.target.value,
                        event,
                        `${selectedControl.id} + ${key}`
                      )
                    }    
                    onBlur={(event) =>
                      handleProperty(key, event.target.value, event)
                    }
                    onPaste={(event) => handleCustomIdPaste(key, event)}
                  />
                </div>
              </>
              :
            (
              <>
                <div>
                  <input
                    aria-label={"Control Value4"}
                    type="text"
                    defaultValue={
                      key === "Label"
                        ? selectedControl.id
                        : selectedControl?.style[key]
                    }
                    key={selectedControl.id}
                    id={selectedControl.id + key}
                    className={[
                      classes.fullWidthTextBox,
                      errorMessageId === selectedControl.id + key
                        ? styles.inputBoxErrorStyle
                        : null,
                    ].join(" ")}
                    onKeyPress={(event) =>
                      validateRegex(
                        key,
                        event.target.value,
                        event,
                        `${selectedControl.id} + ${key}`
                      )
                    }
                    onKeyUp={(event) =>
                      validateRegex(
                        key,
                        event.target.value,
                        event,
                        selectedControl.id + key
                      )
                    }
                    onBlur={(event) =>
                      handleProperty(key, event.target.value, event)
                    }
                  />
                </div>
              </>
            )}

            {mappingField ? (
              <div id="quickProp_Mapping">
                <MappingFile
                  stateOpen={true}
                  setMappingField={setMappingField}
                  controlData={props.selectedControl}
                  elementType={props.selectedControl.controlName === "slider" ? props.selectedControl.controlName :  props.selectedControl.elem_type}
                />
              </div>
            ) : null}

            {errorMessageId === selectedControl.id + key ? (
              <ErrorMessageComponent errorMessage="non-permissible value" />
            ) : null}
          </Form.Group>
        );

      case "icon":
        if (key === "PickerType") {
          return (
            <div className={styles.DatePickerIconDiv}>
              <Row className={styles.datePickerTypeRow}>
                <div
                  className={
                    selectedControl.style["PickerType"] === "1"
                      ? styles.DatePickerTypeSelected
                      : styles.DatePickerType
                  }
                  onClick={() => handleProperty(key, "1")}
                >
                  <div className={styles.DatePickerTypeIcon}>
                    <DatePickerType />
                  </div>
                </div>
                <div
                  className={
                    selectedControl.style["PickerType"] === "2"
                      ? styles.DatePickerTypeSelected
                      : styles.DatePickerType
                  }
                  onClick={() => handleProperty(key, "2")}
                >
                  <div className={styles.DatePickerTypeIcon}>
                    <DateTimePickerType />
                  </div>
                </div>
              </Row>
              <Row>
                <div className={styles.DatePickerTypeLabel}>
                  <label aria-label="Date">Date</label>
                </div>
                <div className={styles.DatePickerTypeLabel}>
                  <label aria-label="Date & Time">Date & Time</label>
                </div>
              </Row>
            </div>
          );
        } else {
          return (
            <div style={{ padding: "5px 0px", maxWidth: "245px" }}>
              {selectedControl &&
              selectedControl.style["Enable"] !== undefined &&
              selectedControl.style["Enable"] !== null &&
              selectedControl.style["Enable"] === "false" ? (
                <>
                  <ActiveIcon
                    property="ControlStyle"
                    passedValue={
                      selectedControl.style["ControlStyle"] === "" ||
                      selectedControl.style["ControlStyle"] === undefined ||
                      selectedControl.style["ControlStyle"] === null
                        ? "style1"
                        : selectedControl.style["ControlStyle"]
                    }
                    handleStyleType={handleStyleType}
                  >
                    <Style1Icon value="Style1" label="Style1" />
                    <Style2Icon value="Style2" label="Style2" />
                    <Style3Icon value="Style3" label="Style3" />
                    <Style3Icon value="Style4" label="Style4" />
                  </ActiveIcon>
                </>
              ) : (
                <>
                  <ActiveIcon
                    property="ControlStyle"
                    passedValue={
                      selectedControl.style["ControlStyle"] === "" ||
                      selectedControl.style["ControlStyle"] === undefined ||
                      selectedControl.style["ControlStyle"] === null
                        ? "style1"
                        : selectedControl.style["ControlStyle"]
                    }
                    handleStyleType={handleStyleType}
                  >
                    <Style1Icon value="Style1" label="Style1" />
                    <Style2Icon value="Style2" label="Style2" />
                    <Style3Icon value="Style3" label="Style3" />
                  </ActiveIcon>
                </>
              )}
            </div>
          );
        }

      case "text":
        return (
          <div>
            <div className={classes.labelTextBox}>
              <div className={classes.label}>
                {" "}
                {t(`translation:${ControlsMap[key].label}`)}{" "}
              </div>
              <textarea
                aria-label={selectedControl.style[key]}
                rows="2"
                className={[
                  classes.textArea,
                  errorMessageId === selectedControl.id + key
                    ? styles.inputBoxErrorStyle
                    : null,
                ].join(" ")}
                defaultValue={
                  (selectedControl &&
                    selectedControl.style &&
                    selectedControl.style[key]) ||
                  key === "Label"
                    ? selectedControl.id
                    : ""
                }
                key={selectedControl.id}
                id={selectedControl.id + key}
                placeholder={key === "SpecialCharacter" ? "eg:@,!,&" : null}
                onKeyPress={(event) =>
                  validateRegex(
                    key,
                    event.target.value,
                    event,
                    selectedControl.id + key
                  )
                }
                onKeyUp={(event) =>
                  validateRegex(
                    key,
                    event.target.value,
                    event,
                    selectedControl.id + key
                  )
                }
                maxLength={
                  props.selectedControl.elem_type !== "checkbox" &&
                  props.selectedControl.elem_type !== "label"
                    ? window?.psh_configs?.label_max_length
                    : ""
                }
                onBlur={(event) => handleProperty(key, event.target.value)}
              ></textarea>
            </div>
            {errorMessageId === selectedControl.id + key ? (
              <ErrorMessageComponent errorMessage="non-permissible value" />
            ) : null}
          </div>
        );

      case "height":
        return (
          <div className={styles.parentDiv}>
            <span className={styles.leftLabel}>
              {t(`translation:${ControlsMap[key].label}`)}
            </span>
            <div className={styles.RightTextBox}>
              <input
                aria-label={"Control Value5"}
                type="text"
                onBlur={(event) => handleProperty(key, event.target.value)}
                defaultValue={
                  (selectedControl &&
                    selectedControl.style &&
                    selectedControl.style[key]) ||
                  ""
                }
                key={selectedControl.id}
                className={styles.RightLabelTextBox}
                onKeyPress={(event) =>
                  validateRegex(
                    key,
                    event.target.value,
                    event,
                    selectedControl.id + key
                  )
                }
                onKeyUp={(event) =>
                  validateRegex(
                    key,
                    event.target.value,
                    event,
                    selectedControl.id + key
                  )
                }
              />
              <div className={translationStyles1 ? styles.RightTextboxPlaceholderArabic : styles.RightTextboxPlaceholder}>PX</div>
            </div>
          </div>
        );

      case "inputradio":
        return (
          <form>
            <div className="inputradio">
              {value.label.map((item) => {

                return (
                  <div
                    style={{
                      display:
                        selectedControl?.elem_type === "listbox"
                          ? "flex"
                          : "initial",
                    }}
                  >
                    <input
                      aria-label={"Control Value6"}
                      type="radio"
                      id={item.name}
                      name={value.field}
                      checked={item.value === selectedControl.style.ComboType}
                      value={item.value}
                      onClick={(e) => handleToggleWithEvent(e, value.field)}
                    />
                    <label aria-label={item.name} htmlFor={item.name}>
                      {" "}
                      &nbsp; {t(`translation:${item.name}`)}
                    </label>
                  </div>
                );
              })}
            </div>
          </form>
        );

      case "combo":
        return (
          <>
            <div
              className={styles.parentDiv}
              style={translationStyles1 ? { display: "flex", marginTop: key==="LinkAlignment" ? "8px" : null } : {marginTop: key==="LinkAlignment" ? "8px" : null}}
            >
              <span className={styles.leftLabel}>
                {t(`translation:${ControlsMap[key].label}`)}
              </span>
              <div className={styles.RightLabelSelectForText}>
                <select
                  id={selectedControl.id + key}
                  className={styles.RightLabelSelectForText}
                  onChange={() =>
                    selectedOptionForLabel(
                      selectedControl.id,
                      ControlsMap[key].label,
                      key
                    )
                  }
                >
                  {ControlsMap[key].children.map(
                    (optionTagData, optionCount) => {
                      if (ControlsMap[key].children[optionCount].Value) {
                        return (
                          <>
                            {ControlsMap[key].children[optionCount].Value ===
                            selectedControl.style[key] ? (
                              <option
                                value={
                                  ControlsMap[key].children[optionCount].Value
                                }
                                selected
                              >
                                {t(ControlsMap[key].children[optionCount].Title)}
                              </option>
                            ) : (
                              <option
                                value={
                                  ControlsMap[key].children[optionCount].Value
                                }
                              >
                                {t(ControlsMap[key].children[optionCount].Title)}
                              </option>
                            )}
                          </>
                        );
                      }
                    }
                  )}
                </select>
              </div>
            </div>
          </>
        );

      case "buttonlabel":
        return (
          <div className={styles.parentDiv}>
            <div className={styles.leftLabel}>
              {t(`translation:${ControlsMap[key].label}`)}
            </div>
            {key !== "CustomControlID" ? (
              <div className={styles.RightLabelDivButtonLabel}>
                <input
                  aria-label={"Control Value7"}
                  type="text"
                  className={[
                    styles.RightLabelTextInput,
                    errorMessageId === selectedControl.id + key
                      ? styles.inputBoxErrorStyle
                      : null,
                  ].join(" ")}
                  defaultValue={selectedControl.style["ButtonLabel"]}
                  onKeyPress={(event) =>
                    validateRegex(
                      key,
                      event.target.value,
                      event,
                      selectedControl.id + key
                    )
                  }
                  onKeyUp={(event) =>
                    validateRegex(
                      key,
                      event.target.value,
                      event,
                      selectedControl.id + key
                    )
                  }
                  onBlur={(event) => handleProperty(key, event.target.value)}
                />
              </div>
            ) : (
              <>
                <div className={styles.RightLabelDivCustomID}>
                  <input
                   aria-label={"Control Value9"}
                    type="text"
                    className={[
                      styles.RightLabelCustomID,
                      errorMessageId === selectedControl.id + key
                        ? styles.inputBoxErrorStyle
                        : null,
                    ].join(" ")}
                    onKeyPress={(event) =>
                      validateRegex(
                        key,
                        event.target.value,
                        event,
                        selectedControl.id + key
                      )
                    }
                    onKeyUp={(event) =>
                      validateRegex(
                        key,
                        event.target.value,
                        event,
                        selectedControl.id + key
                      )
                    }
                    onBlur={(event) => handleProperty(key, event.target.value)}
                  />
                </div>
              </>
            )}
            {errorMessageId === selectedControl.id + key ? (
              <ErrorMessageComponent errorMessage="non-permissible value" />
            ) : null}
          </div>
        );

      case "textareaurl":
        return (
          <div>
            <div className={styles.leftLabelForTextBox}>
              <p>{t(`translation:${ControlsMap[key].label}`)}</p>
            </div>
            <div>
              <textarea
                className={styles.checkBoxLayoutStyletextAreaURLQuick}
                defaultValue={
                  (selectedControl &&
                    selectedControl.style &&
                    selectedControl.style[key]) ||
                  key === "Label"
                    ? selectedControl.id
                    : ""
                }
                key={selectedControl.id}
                onBlur={(event) => handleProperty(key, event.target.value)}
              />
            </div>
          </div>
        );

      case "longinput":
        return (
          <>
            <div className="longinput">
              {t(`translation:${value.label}`)}
              <input
                aria-label={"Control Value10"}
                type="text"
                autoComplete="off"
                rows="2"
                defaultValue={props.selectedControl.style[key]}
                key={
                  props.selectedControl.id + props.selectedControl.style[key]
                }
                className={[
                  errorMessageId === selectedControl.id + key
                    ? styles.inputBoxErrorStyle
                    : null,
                ].join(" ")}

                onKeyPress={(event) =>
                  validateRegex(
                    value.field,
                    event.target.value,
                    event,
                    selectedControl.id + key
                  )
                }
                onKeyUp={(event) =>
                  validateRegex(
                    value.field,
                    event.target.value,
                    event,
                    selectedControl.id + key
                  )
                }
                onBlur={(e) => handleSupProperty(value.field, e.target.value)}
              />
            </div>
            {errorMessageId === selectedControl.id + key ? (
              <ErrorMessageComponent errorMessage="non-permissible value" />
            ) : null}
          </>
        );

      case "layout":
        return (
          <>
            <div className="label"> {t("translation:Layout")} </div>
            <ActiveIcon
              layout="3"
              defaultValue="1"
              spacing="0"
              labelPosition="in"
              labelStyle={{ fontSize: "11px" }}
              
              activeStyle={{
                padding: "3px",
                margin: "0",
                background: "#fff",
                border: "1px solid #0072c6",
                width: "81px",
                color: "#0072C6",
              }}
              inActiveStyle={{
                padding: "3px",
                margin: "0",
                background: "#fff",
                border: "1px solid #c6c9cf",
                width: "81px",
              }}
              passedValue={String(findFrameColumnLayout(selectedControl, currentDeviceOnApp)) || "4"}
              property={value.field}
              handleStyleType={getSelectedLayout}
            >
                <TabColumn1 value="1" label="1 COLUMN" style={{ paddingRight: "9px" }} />
                <TabColumn2 value="2" label="2 COLUMNS"style={{paddingRight:"9px"}}  />
                <TabColumn3 value="3" label="3 COLUMNS"style={{paddingRight:"9px"}}  />
                <TabColumn4 value="4" label="4 COLUMNS"style={{paddingRight:"9px"}}  />
                <TabColumn5 value="6" label="6 COLUMNS"style={{paddingRight:"9px"}}  />
                <TabColumn6 value="12" label="12 COLUMNS"style={{paddingRight:"9px"}}  />
            </ActiveIcon>
          </>
        );

      case "fullwidthinputbutton":
        return (
          <>
            <div
              tabIndex={0}
              className={styles.addColumnButtonDiv + " qtwidebutton"}
              onClick={addColumn}
            >
              <span
                className={styles.addColumnIconSpan}
                style={{ marginBottom: "4px" }}
              >
                <AddColumnIcon />
              </span>
              {t(`translation:${ControlsMap[key].label}`)}
            </div>
          </>
        );

      case "toggleshort":
        
        return (
          <>
            
            <div key={value.label} className={classes.toggleshort}>
              <div className={classes.toggleLabel}>
                {t(`translation:${value.label}`)}{" "}
              </div>
              <ToggleBtnQuickTool
                handleToggleRef={handleToggle}
                field={value.field + ""}
                toggleState={selectedControl.style[value.field + ""] || ""}
                externalStyling={{
                  quickToolSlideBarStyle: {
                    height: "20px",
                    display: "flex",
                    alignItems: "center",
                  },
                  quickToolSwitchStyle: "quickToolSwitchStyle",
                }}
              />
            </div>
          </>
        );

      case "stepssubsteps":
        return (
          <div
            className="stepssubsteps_parent_wizard"
            style={{
              // height: "35vh",
              // padding: "11px",
              overflowX: "hidden",
              overflowY: "auto",
              maxHeight: "min(250px, 35vh)"
            }}
          >
            {props.selectedControl.children &&
              ((
                shouldShowLoader
                  ? props.selectedControl.children.length ===
                    parseInt(
                      window?.psh_configs?.wizard_initial_step_count
                    )
                  : props.selectedControl.children.length
              )
                ? props.selectedControl.children.map((step, stepIndex) => (
                    <div
                      key={step.id}
                      className={`stepssubstepsMain  stepssubstepsMain${step.id}`}
                      onClick={() => handleActiveStep(step.id)}
                    >
                      <div
                        className="cardlabelvalue stepssubsteps"
                        // draggable={true}
                        onDragStart={(event) =>
                          registerOptionToReposition(event, stepIndex)
                        }
                        onDragOver={(event) => allowDrop(event)}
                        onDragLeave={(event) => dragLeave(event)}
                        onDrop={(event) => repositionThisOption(event)}
                        option_index={stepIndex}
                        option_parent={"true"}
                        style = {{padding:'8px'}}
                      >
                        <p
                          className={classes.stepIndex}
                          option_index={stepIndex}
                          style={{margin:'0px 0px 8px 0px',}}
                        >
                          {t("Step")} {stepIndex + 1}
                          {activeStep === step.id ? (
                            <CollapsibleArrowUp />
                          ) : (
                            <CollapsibleArrowDown />
                          )}
                        </p>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginRight: "2px",
                            marginBottom:activeStep === step.id && selectedControl.style["showIcons"] === "true" && '8px',
                            marginLeft:'0px'
                          }}
                          option_index={stepIndex}
                        >
                          {/* <Svgdrag
                            className={"dragIcon6dot"}
                            color={"#afafaf"}
                            option_index={stepIndex}
                          /> */}
                          <input
                            aria-label={"Control Value11"}
                            autoComplete="off"
                            placeholder={step.stepName}
                            defaultValue={step.stepName}
                            onClick={(e) => e.stopPropagation()}
                            onBlur={(e) => handleStep(e, stepIndex)}
                            name="stepName"
                            style={{margin:"unset",height:'28px'}}
                            maxLength={
                              props.selectedControl.elem_type !== "checkbox" &&
                              props.selectedControl.elem_type !== "label"
                                ? window?.psh_configs
                                    ?.label_max_length
                                : ""
                            }
                            option_index={stepIndex}
                          />
                          <span
                            style={{ margin: "", height: "fit-content" }}
                            onClick={() => deleteStep(step.id, stepIndex)}
                            option_index={stepIndex}
                            tabIndex={0}
                          >
                            <RedCross className="redCrossStepIcon" />
                          </span>
                        </div>

                        {selectedControl.style["showIcons"] === "true" &&
                          activeStep === step.id && (
                            <div
                              onClick={(e) => e.stopPropagation()}
                              option_index={stepIndex}
                              style={{marginLeft: '0px'}}
                            >
                              <ImageUploadBtn
                                containerId={props.containerId}
                                uploadindex={stepIndex}
                                handleImageUpload={handleIconForWizard}
                                iconName={
                                  (step && step.icon && step.icon.name) || ""
                                }
                                option_index={stepIndex}
                                parentStyle={{ width: "77.5%" }}
                              />
                            </div>
                          )}
                      </div>

                      {selectedControl.style["showSubsteps"] === "true" &&
                        activeStep === step.id && (
                          <div
                            onClick={(e) => e.stopPropagation()}
                            style={{ backgroundColor: "white", padding:'8px'}}
                            className="cardlabelvalue substeps"
                            option_index={stepIndex}
                          >
                            <p
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                margin: "5px 2px",
                                alignItems:'center',
                                marginBottom:'8px'
                              }}
                              onClick={(e) => e.stopPropagation()}
                              option_index={stepIndex}
                            >
                              <span option_index={stepIndex}>
                                {step.children.length > 0 &&
                                  step.children.findIndex(function (substep) {
                                    return (
                                      substep.elem_type.toLowerCase() ===
                                      "substep"
                                    );
                                  }) !== -1 &&
                                  t(`translation:Substeps`)}
                              </span>
                              <span
                                className={classes.addSubstep}
                                onClick={(e) => handleDoubleClick3(e, stepIndex,props.selectedControl)}
                                option_index={stepIndex}
                              >
                                <PlusOrange color="#338ED1" /> {t(`translation:Substep`)}
                              </span>
                            </p>

                            {step.children.map((substep, subStepIndex) => {
                              return (
                                <>
                                  {substep.elem_type.toLowerCase() ===
                                    "substep" && (
                                    <div
                                      option_index={stepIndex}
                                      key={substep.id}
                                      onClick={(e) => e.stopPropagation()}
                                      className="subStep"
                                      style={{
                                        marginBottom: "8px",
                                        marginRight: "0px",
                                        marginLeft:'0px',
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "baseline",
                                        }}
                                      >
                                        {/* <Svgdrag
                                          className={"dragIcon6dot"}
                                          color={"#afafaf"}
                                        /> */}
                                        <input
                                          aria-label={"Control Value12"}
                                          autoComplete="off"
                                          placeholder={substep.substepName}
                                          defaultValue={substep.substepName}
                                          onClick={(e) => e.stopPropagation()}
                                          onBlur={(e) =>
                                            handleSubStep(
                                              e,
                                              stepIndex,
                                              subStepIndex
                                            )
                                          }
                                          name="substepName"
                                        />
                                        <span
                                          tabIndex={0}
                                          onClick={() =>
                                            deleteSubStep(
                                              substep,
                                              stepIndex,
                                              subStepIndex
                                            )
                                          }
                                        >
                                          <RedCross />
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                </>
                              );
                            })}
                          </div>
                        )}
                    </div>
                  ))
                : shouldShowLoader && <SimpleLoader open={true} />)}
          </div>
        );

      case "widebutton":
        return (
          <div
            tabIndex={0}
            className="widebutton qtwidebutton"
            style={value.style}
            onClick={() => handleDoubleClick2(props.selectedControl)}
          >
            <PlusBlue />
            <span>{t(`translation:${value.label}`)}</span>
          </div>
        );

      case "picklist":
        return (
          <div
            className="text"
            style={{ color: value.color, fontWeight: value.weight }}
          >
            {t(`translation:${value.label}`)}
            <div
              style={{
                border: "1px solid #c4c4c4",
                height: "24px",
                display: "flex",
                margin: "4px 0",
                alignItems: "center",
              }}
            >
              <InputBase
                inputProps={{
                  "aria-label":"Control Value13"
                }}
                aria-label={"Control Value13"}
                style={{ height: "24px", width: "239px" }}
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
              />
              {filter === "" ? (
                ""
              ) : (
                <button
                  style={{
                    background: "none",
                    border: "none",
                    height: "10px !important",
                    lineHeight: "0 !important",
                    padding: "0px 2px !important",
                    margin: "-5px 2px !important",
                  }}
                  onClick={() => {
                    setFilter("");
                  }}
                >
                  <Cross style={{ width: "16px", height: "16px" }}></Cross>
                </button>
              )}

              <Divider orientation="vertical" />

              <button
                style={{
                  background: "none",
                  border: "none",
                  height: "10px !important",
                  lineHeight: "0 !important",
                  padding: "0px 2px !important",
                  margin: "-5px 2px !important",
                }}
                onClick={() => {
                  handleOpen();
                }}
              >
                <DOTS style={{ width: "36px", height: "4px" }}></DOTS>
              </button>
              <Modal open={open} onClose={handleClose}>
                <ReportModal
                  closeModal={handleClose}
                  data={props.selectedControl}
                  containerId={props.containerId}
                />
              </Modal>
            </div>
          </div>
        );

      case "pageconfig":
        return (
          <>
            <div className={styles.controlTitle}>Page Title </div>
            <div className={styles.template}>
              <span className={styles.templateLeft}>Template</span>
              <button className={styles.templateButton}>Select</button>
            </div>
            <div className={styles.templateBody}>
              <p className={styles.templateBodyText}>None</p>
            </div>
          </>
        );

      case "pagedisplay":
        return (
          <>
            <div className={styles.configurationHeaderDiv}>Page Display</div>
          </>
        );

      case "tilecontent":
        return (
          <>
            <form>
              <span className={styles.leftLabelButtonType}>
                {t(`translation:${ControlsMap[key].label}`)}
              </span>
              <div className={`${styles.tileContentType}`}>
                <div
                  className={styles.tileContentType1}
                  style={{ display: "flex" }}
                >
                  <div
                    className={styles.titleContentBox}
                    style={
                      translationStyles1
                        ? {
                            marginRight: "unset",
                            marginLeft: "7px",
                            paddingLeft: "unset",
                          }
                        : null
                    }
                  >
                    <input
                      aria-label={"Control Value15"}
                      className={
                        !translationStyles1
                          ? styles.checkBoxTile
                          : styles.checkBoxTile1
                      }
                      type="checkbox"
                      checked={
                        selectedControl.style &&
                        selectedControl.style["Title"] === "true"
                          ? true
                          : false
                      }
                      onClick={(e) => changeTileContentCheck("Title")}
                    />
                    <p style={{ marginLeft: "5px", marginBottom: "0px" }}>
                      {t(`translation:${"Title"}`)}
                    </p>
                  </div>
                  <div
                    className={styles.titleContentBox}
                    style={
                      translationStyles1
                        ? {
                            marginRight: "unset",
                            marginLeft: "7px",
                            paddingLeft: "unset",
                          }
                        : null
                    }
                  >
                    <input
                      aria-label={"Control Value16"}
                      className={
                        !translationStyles1
                          ? styles.checkBoxTile
                          : styles.checkBoxTile1
                      }
                      type="checkbox"
                      onClick={() => changeTileContentCheck("Image")}
                      checked={
                        selectedControl.style &&
                        selectedControl.style["Image"] === "true"
                          ? true
                          : false
                      }
                    />
                    <p style={{ marginLeft: "5px", marginBottom: "0px" }}>
                      {t(`translation:${"Image"}`)}
                    </p>
                  </div>
                  <div
                    className={styles.titleContentBox}
                    style={
                      translationStyles1
                        ? {
                            marginRight: "unset",
                            marginLeft: "7px",
                            paddingLeft: "unset",
                          }
                        : null
                    }
                  >
                    <input
                      aria-label={"Control Value17"}
                      className={
                        !translationStyles1
                          ? styles.checkBoxTile
                          : styles.checkBoxTile1
                      }
                      type="checkbox"
                      onClick={() => changeTileContentCheck("Description")}
                      checked={
                        selectedControl.style &&
                        selectedControl.style["Description"] === "true"
                          ? true
                          : false
                      }
                    />
                    <p style={{ marginLeft: "5px", marginBottom: "0px" }}>
                      {t(`translation:${"Description"}`)}
                    </p>
                  </div>
                </div>

                <div className={styles.tileContentType1}>
                  <div
                    className={styles.titleContentBox}
                    style={
                      translationStyles1
                        ? {
                            marginRight: "unset",
                            marginLeft: "7px",
                            paddingLeft: "unset",
                          }
                        : null
                    }
                  >
                    <input
                     aria-label={"Control Value18"}
                      className={
                        !translationStyles1
                          ? styles.checkBoxTile
                          : styles.checkBoxTile1
                      }
                      type="checkbox"
                      onClick={() => changeTileContentCheck("Points")}
                      checked={
                        selectedControl.style &&
                        selectedControl.style["Points"] === "true"
                          ? true
                          : false
                      }
                    />
                    <p style={{ marginLeft: "5px", marginBottom: "0px" }}>
                      {t(`translation:${"Points"}`)}
                    </p>
                  </div>
                  <div
                    className={styles.titleContentBox}
                    style={
                      translationStyles1
                        ? {
                            marginRight: "unset",
                            marginLeft: "7px",
                            paddingLeft: "unset",
                          }
                        : null
                    }
                  >
                    <input
                      aria-label={"Control Value19"}
                      className={
                        !translationStyles1
                          ? styles.checkBoxTile
                          : styles.checkBoxTile1
                      }
                      type="checkbox"
                      onClick={() => changeTileContentCheck("Button")}
                      checked={
                        selectedControl.style &&
                        selectedControl.style["Button"] === "true"
                          ? true
                          : false
                      }
                    />
                    <p style={{ marginLeft: "5px", marginBottom: "0px" }}>
                      {t(`translation:${"Button"}`)}
                    </p>
                  </div>
                  <div
                    className={styles.titleContentBox}
                    style={
                      translationStyles1
                        ? {
                            marginRight: "unset",
                            marginLeft: "7px",
                            paddingLeft: "unset",
                          }
                        : null
                    }
                  >
                    <input
                      aria-label={"Control Value20"}
                      className={
                        !translationStyles1
                          ? styles.checkBoxTile
                          : styles.checkBoxTile1
                      }
                      type="checkbox"
                      onClick={() => changeTileContentCheck("Link")}
                      checked={
                        selectedControl.style &&
                        selectedControl.style["Link"] === "true"
                          ? true
                          : false
                      }
                    />
                    <p style={{ marginLeft: "5px", marginBottom: "0px" }}>
                      {t(`translation:${"Link"}`)}
                    </p>
                  </div>
                </div>
              </div>
            </form>
          </>
        );

      case "tileselectionmethod":
        return (
          <>
            <div>{t(`translation:${ControlsMap[key].label}`)}</div>
            <form>
              <div className={styles.additionMethodsDivTile}>
                {ControlsMap[key].children.map((obj) => {
                  return (
                    <div className={styles.additionMethodLabelRadioDivTile}>
                      <input
                        aria-label={"Control Value21"}
                        type="radio"
                        id={obj.Title}
                        name="additionmethods"
                        checked={
                          selectedControl &&
                          selectedControl.style["TileSelectionType"] &&
                          selectedControl.style[
                            "TileSelectionType"
                          ].toString() === obj.Title
                            ? true
                            : false
                        }
                        onClick={() => handleDataAddition(obj.Title)}
                      />
                      <label
                      aria-label={obj.Title}
                        className={styles.labelRadioTile}
                        for={obj.Title}
                        onClick={() => handleDataAddition(obj.Title)}
                      >
                        {t(`translation:${obj.Title}`)}
                      </label>
                    </div>
                  );
                })}
              </div>
            </form>
          </>
        );

      case "radio":
        return (
          <div className={styles.parentDiv}>
            <span className={styles.propertiesHeader1} style={translationStyles1?{textAlign:"right"}:null}>
              {t(`translation:${ControlsMap[key].label}`)}
            </span>
            <form className={styles.flexColumnDiv}>
              {ControlsMap[key].children.map((child, index) => {
                if (child) {
                  return (
                    <div className={styles.documentsUploadModeDiv}>
                      <input
                        aria-label={"Control Value22"}
                        name="selectionMethod"
                        type="radio"
                        id={child.Value}
                        value={child.Value}
                        className={styles.documentsUploadModeRadio}
                        checked={selectedControl?.style?.[key] === child.Value}
                        onClick={() => handleProperty(key, child.Value)}
                      />
                      <label
                        aria-label={child.Value}
                        htmlFor={child.Value}
                        className={styles.imageCarouselSpan}
                        onClick={() => handleProperty(key, child.Value)}
                        style={{ marginBottom: "0px" }}
                      >
                        {t(`translation:${child.Title}`)}
                      </label>
                    </div>
                  );
                }
              })}
            </form>
          </div>
        );

      case "boxwithicon":
        return (
          <div>
            <span className={styles.leftLabel}>
              {t(`translation:${ControlsMap[key].label}`)}
            </span>
            <br />
            <div className={styles.eventsOnClickLink}>
              {ControlsMap[key].children.map((optionTagData, optionCount) => {
                switch (
                  ControlsMap[key].children[optionCount].Title.toLowerCase()
                ) {
                  case "page":
                    return (
                      <div
                        className={
                          selectedControl.style["OnClick"] === "Code"
                            ? styles.eventsOnClickSelectedInnerDiv
                            : styles.eventsOnClickInnerDiv
                        }
                        onClick={() => selectedOptionForLinkIcon("Code")}
                        id={ControlsMap[key].children[
                          optionCount
                        ].Title.toLowerCase()}
                      >
                        <CodeIcon />
                      </div>
                    );
                  case "url":
                    return (
                      <div
                        className={
                          selectedControl.style["OnClick"] === "URL"
                            ? styles.eventsOnClickSelectedInnerDiv
                            : styles.eventsOnClickInnerDiv
                        }
                        onClick={() => selectedOptionForLinkIcon("URL")}
                        id={ControlsMap[key].children[
                          optionCount
                        ].Title.toLowerCase()}
                      >
                        <LinkIcon />
                      </div>
                    );

                  default:
                    return null;
                }
              })}
            </div>
            <div className={styles.eventsOnClickTextParentDivLink}>
              {ControlsMap[key].children.map((optionTagData, optionCount) => {
                return (
                  <>
                    {ControlsMap[key].children[optionCount].Title !== "Link" &&
                    ControlsMap[key].children[optionCount].Title !== "More" &&
                    ControlsMap[key].children[optionCount].Title !== "Page" &&
                    ControlsMap[key].children[optionCount].Title !==
                      "Subform" ? (
                      <div className={styles.eventsOnClickTextInnerDiv}>
                        {t(
                          `translation:${ControlsMap[key].children[optionCount].Title}`
                        )}
                      </div>
                    ) : null}
                  </>
                );
              })}
            </div>
          </div>
        );

      case "text_top_bottom_method":
        return (
          <>
            {selectedControl.style["OnClick"] !== undefined ? (
              <Form.Group className={styles.parentDivTopBottom}>
                <div>
                  {selectedControl.style["OnClick"] === "URL" &&
                  key !== "MethodName" &&
                  key === "LinkURL" ? (
                    <span className={styles.topBottomLabel}>
                      {t(`translation:${ControlsMap[key].label}`)}
                    </span>
                  ) : null}

                  {selectedControl.style["OnClick"] === "Code" &&
                  key !== "LinkURL" &&
                  key === "MethodName" ? (
                    <span className={styles.topBottomLabel}>
                      {ControlsMap[key].label}
                    </span>
                  ) : null}
                </div>
                <div>
                  {selectedControl.style["OnClick"] === "URL" &&
                  key !== "MethodName" &&
                  key === "LinkURL" ? (
                    <input
                      aria-label={"Control Value23"}
                      type="text"
                      defaultValue={
                        (selectedControl &&
                          selectedControl.style &&
                          selectedControl.style[key]) ||
                        key === "Label"
                          ? selectedControl.id
                          : ""
                      }
                      key={selectedControl.id}
                      className={styles.fullWidthTextBox}
                      onBlur={(event) =>
                        handleProperty(key, event.target.value)
                      }
                    />
                  ) : null}

                  {selectedControl.style["OnClick"] === "Code" &&
                  key !== "LinkURL" &&
                  key === "MethodName" ? (
                    <input
                      aria-label={"Control Value24"}
                      type="text"
                      defaultValue={selectedControl.style[key]}
                      key={selectedControl.id}
                      className={styles.fullWidthTextBox}
                      onBlur={(event) =>
                        handleProperty(key, event.target.value)
                      }
                    />
                  ) : null}
                </div>
                {errorMessageId === selectedControl.id + key ? (
                  <ErrorMessageComponent errorMessage="non-permissible value" />
                ) : null}
              </Form.Group>
            ) : null}
          </>
        );

      default:
        return null;
    }
  }

  const container = document.getElementById(props?.containerId) || document.getElementById("IFormDesignerLayout_id")

  return props.open && openQuickToolFor === props.selectedControl?.id ? (
    <>
      
      <ClickAwayListener
        mouseEvent="onMouseDown"
        touchEvent="onTouchStart"
        onClickAway={(e) => handleCancel(e,"clickAway")}
      >
    <Dialog
        open={true}
        // classes={{ paper: classes.dialog, root: classes.root, container: classes.container  }}
        // onClose={handleClose}
        // container={() => document.getElementById("canvasId")}
        className="formBuilder_main_app"
        style={{ zIndex: 1298 }}
        disableBackdropClick={false}
        onClose={(e) => handleCancel(e,"clickAway")}
        container={container}
        // key={props?.subFormListviewJson?.id}
        // id={`${props.subFormListviewJson.id}_advListviewPopup`}
      >

        <div ref={quickToolRef}>
          <div
            tabIndex="0"
            onKeyDown={(e) => handleEscapeKey(e)}
            className={classes.quickTools}
            style={{...(formState2?.style?.formCustomHeight ? {height: `${formState2?.style?.formCustomHeight}%`, overflow: "auto"} : {}), ...(translationStyles1 ? { textAlign: "right" } : {})}}
            id="backdropDiv"
          >
            <DialogTitle classes={{ root: classes.dialogTitle }}>
              <span className={classes.dialogHead}>
                {t(`translation:Quick Properties`)}
              </span>
              <span className={classes.controlHead}>
                -{" "}
                {selectedControl &&
                selectedControl.elem_type == "textbox" &&
                selectedControl.style &&
                selectedControl.style.isPassword == true
                  ? `${t(`translation:${elemTypeJsonMap["password"]}`)}`
                  : selectedControl.ControlType == "slider" ? `${t(`translation:slider`)}` : `${t(`translation:${elemTypeJsonMap[selectedControl.elem_type]}`)}`}
              </span>
            </DialogTitle>

            <DialogContent classes={{ root: classes.dialogContent }}>
              {Items.map((item, index) => {
                return item;
              })}
              {showTableBackdrop === true ? (
                <TableBackdrop
                  formData={props.formData}
                  containerId={props.containerId}
                  columnNamesList={columnNamesList}
                  existingColumnsIndex={existingColumnsIndex}
                  columnsStyle={columnsStyle}
                  selectedColumnOldProperties={selectedColumn}
                  setShowTableBackdrop={(arg, obj) => handleBackdrop(arg, obj)}
                  data={selectedControl}
                  columnPropertiesJson={ColumnPropertiesJson}
                  selectedColumn={selectedColumn}
                  setSelectedColumn={(column) => setSelectedColumn(column)}
                  applyChanges={(obj) => props.applyChanges(obj)}
                />
              ) : null}
            </DialogContent>

            <DialogActions classes={{ root: classes.dialogActions }}>
             
              <span
                className={classes.btn1}
                onClick={(e) => handleCancel(e,"Cancel")}
                tabIndex={0}
              >
                <img
                  src={
                    require("../../Icons/QuickProperties/cancel.svg").default
                  }
                  title="Cancel"
                  className={classes.icons}
                  alt="Cancel Icon"
                />
                &nbsp; {t(`translation:Cancel`)}
              </span>
              <span className={classes.btn2} onClick={handleView} tabIndex={0}>
                <img
                  src={
                    require("../../Icons/QuickProperties/viewall.svg").default
                  }
                  title="View all"
                  className={classes.icons}
                  alt="View all Icon"
                />
                &nbsp; {t(`translation:View all`)}
              </span>
              <span className={classes.btn3} onClick={handleDone} tabIndex={0}>
                <img
                  src={require("../../Icons/QuickProperties/done.svg").default}
                  title="Done"
                  className={classes.icons}
                  alt="Done Icon"
                />
                &nbsp; {t(`translation:Done`)}
              </span>
            </DialogActions>
          </div>
          {
            alertData.open === true &&
            <CustomizedAlert
              alertData={alertData}
              handleFunction={(alertData?.sheetIndex || alertData?.sheetIndex === 0) ? (sheetId, sheetIndex) =>
                deleteSheet(sheetId, sheetIndex) : {}
              }
            />
          }

          {editableImage == true && props.selectedControl ? (
            <ImageEditor
              open={true}
              containerId={props.containerId}
              selectedControl={props.selectedControl}
              key={editableImage}
              imageDetails={{
                imageFile:
                  props.selectedControl.style.imageList[imgInd].imageFile,
              }}
              imageStyle={
                props.selectedControl.style.imageList[imgInd].imageStyle
              }
              handleImageEditing={(arg, imgDetails, imgStyle) =>
                handleImageEditing(arg, imgDetails, imgStyle)
              }
              handleClose={handleEditImgClose}
            />
          ) : (
            <></>
          )}
        </div>
    </Dialog>

      </ClickAwayListener>
    </>
  ) : (
    <></>
  );
}
